(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * isMobile.js v0.4.1
 *
 * A simple library to detect Apple phones and tablets,
 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
 * and any kind of seven inch device, via user agent sniffing.
 *
 * @author: Kai Mallea (kmallea@gmail.com)
 *
 * @license: http://creativecommons.org/publicdomain/zero/1.0/
 */
(function (global) {

    var apple_phone         = /iPhone/i,
        apple_ipod          = /iPod/i,
        apple_tablet        = /iPad/i,
        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
        android_tablet      = /Android/i,
        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        windows_phone       = /Windows Phone/i,
        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
        other_blackberry    = /BlackBerry/i,
        other_blackberry_10 = /BB10/i,
        other_opera         = /Opera Mini/i,
        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
        seven_inch = new RegExp(
            '(?:' +         // Non-capturing group

            'Nexus 7' +     // Nexus 7

            '|' +           // OR

            'BNTV250' +     // B&N Nook Tablet 7 inch

            '|' +           // OR

            'Kindle Fire' + // Kindle Fire

            '|' +           // OR

            'Silk' +        // Kindle Fire, Silk Accelerated

            '|' +           // OR

            'GT-P1000' +    // Galaxy Tab 7 inch

            ')',            // End non-capturing group

            'i');           // Case-insensitive matching

    var match = function(regex, userAgent) {
        return regex.test(userAgent);
    };

    var IsMobileClass = function(userAgent) {
        var ua = userAgent || navigator.userAgent;

        // Facebook mobile app's integrated browser adds a bunch of strings that
        // match everything. Strip it out if it exists.
        var tmp = ua.split('[FBAN');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
        // iPhone" string. Same probable happens on other tablet platforms.
        // This will confuse detection so strip it out if it exists.
        tmp = ua.split('Twitter');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        this.apple = {
            phone:  match(apple_phone, ua),
            ipod:   match(apple_ipod, ua),
            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
        };
        this.amazon = {
            phone:  match(amazon_phone, ua),
            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
        };
        this.android = {
            phone:  match(amazon_phone, ua) || match(android_phone, ua),
            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
        };
        this.windows = {
            phone:  match(windows_phone, ua),
            tablet: match(windows_tablet, ua),
            device: match(windows_phone, ua) || match(windows_tablet, ua)
        };
        this.other = {
            blackberry:   match(other_blackberry, ua),
            blackberry10: match(other_blackberry_10, ua),
            opera:        match(other_opera, ua),
            firefox:      match(other_firefox, ua),
            chrome:       match(other_chrome, ua),
            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
        };
        this.seven_inch = match(seven_inch, ua);
        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

        // excludes 'other' devices and ipods, targeting touchscreen phones
        this.phone = this.apple.phone || this.android.phone || this.windows.phone;

        // excludes 7 inch devices, classifying as phone or tablet is left to the user
        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

        if (typeof window === 'undefined') {
            return this;
        }
    };

    var instantiate = function() {
        var IM = new IsMobileClass();
        IM.Class = IsMobileClass;
        return IM;
    };

    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
        //node
        module.exports = IsMobileClass;
    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
        //browserify
        module.exports = instantiate();
    } else if (typeof define === 'function' && define.amd) {
        //AMD
        define('isMobile', [], global.isMobile = instantiate());
    } else {
        global.isMobile = instantiate();
    }

})(this);

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.audio
 */
var Audio = function () {
    /**
     * @param {number} id
     * @param {Howl} howl
     */
    function Audio(id, howl) {
        _classCallCheck(this, Audio);

        /**
         * @member {number}
         */
        this._id = id;

        /**
         * @member {Howl}
         */
        this._howl = howl;
    }

    _createClass(Audio, [{
        key: "destroy",
        value: function destroy() {
            this._onend && this.howl.off("end", this._onend);
            this.stop();
        }
    }, {
        key: "play",
        value: function play() {
            this.howl.play(this.id);
        }
    }, {
        key: "stop",
        value: function stop() {
            this.howl.stop(this.id);
        }
    }, {
        key: "pause",
        value: function pause() {
            this.howl.pause(this.id);
        }

        /**
         * @returns {number}
         */

    }, {
        key: "id",
        get: function get() {
            return this._id;
        }

        /**
         * @returns {Howl}
         */

    }, {
        key: "howl",
        get: function get() {
            return this._howl;
        }
    }]);

    return Audio;
}();

exports.default = Audio;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Audio = require("./Audio");

var _Audio2 = _interopRequireDefault(_Audio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.audio
 */
var AudioManager = function () {
    function AudioManager() {
        _classCallCheck(this, AudioManager);

        /**
         * @member {Object}
         * @private
         */
        this._cache = {};

        /**
         * @member {Audio}
         * @private
         */
        this._music = null;

        /**
         * @member {boolean}
         * @private
         */
        this._isMute = false;

        var hidden = void 0;
        "undefined" !== typeof document.hidden ? (hidden = "hidden", this.visibilityChange = "visibilitychange") : "undefined" !== typeof document.mozHidden ? (hidden = "mozHidden", this.visibilityChange = "mozvisibilitychange") : "undefined" !== typeof document.msHidden ? (hidden = "msHidden", this.visibilityChange = "msvisibilitychange") : "undefined" !== typeof document.webkitHidden && (hidden = "webkitHidden", this.visibilityChange = "webkitvisibilitychange");

        document.addEventListener(this.visibilityChange, function () {
            document[hidden] ? Howler.volume(0) : Howler.volume(1);
        }, false);
    }

    /**
     * @param {Array.<string>} sounds
     * @param {Array.<string>} extensions
     * @param {string} [basePath]
     */


    _createClass(AudioManager, [{
        key: "addSounds",
        value: function addSounds(sounds, extensions, basePath) {
            basePath = basePath || "";

            for (var i = 0; i < sounds.length; ++i) {
                var url = basePath + sounds[i];
                url = url.split("/");
                var name = url[url.length - 1];

                var urls = [];
                for (var j = 0; j < extensions.length; ++j) {
                    var extension = extensions[j];
                    urls.push(url.join("/") + extension);
                }
                var howl = new Howl({
                    src: urls,
                    volume: 1.0,
                    loop: false,
                    autoplay: false
                });
                howl.name = name;
                this._cache[name] = howl;
            }
        }

        /**
         * @param {string} name
         * @param {string} sprite
         * @param {Array.<string>} extensions
         * @param {string} [basePath]
         */

    }, {
        key: "addSoundSprite",
        value: function addSoundSprite(name, sprite, extensions, basePath) {
            basePath = basePath || "";

            var url = basePath + name;
            url = url.split("/");

            var urls = [];
            for (var i = 0; i < extensions.length; ++i) {
                var extension = extensions[i];
                urls.push(url.join("/") + extension);
            }

            var howl = new Howl({
                src: urls,
                sprite: sprite,
                volume: 1,
                loop: false,
                autoplay: false
            });
            howl.isSoundSprite = true;
            for (var _i in sprite) {
                if (sprite.hasOwnProperty(_i)) {
                    this._cache[_i] = howl;
                }
            }
        }

        /**
         * @param name
         * @param {object} params
         * @param {number} [params.volume=1]
         * @param {boolean} [params.loop=false]
         * @param {function} [params.callback]
         * @param {*} [params.scope]
         * @param {boolean} [params.destroyOnComplete=false] Destroys the audio once the callback has fired.
         */

    }, {
        key: "playSound",
        value: function playSound(name, params) {
            params = Object.assign({}, { volume: 1, loop: false, destroyOnComplete: false }, params);
            if (typeof name !== "string") {
                name = P3.utils.selectRandom(name);
            }

            var id = -1;
            var howl = this._cache[name];
            if (!howl) {
                console.warn("Could not find sound - " + name);
                return id;
            }

            id = howl.isSoundSprite ? howl.play(name) : howl.play();
            howl.volume(params.volume || 1, id);
            howl.loop(params.loop || false, id);

            var audio = new _Audio2.default(id, howl);
            if (params.callback) {
                audio._onend = function () {
                    params.callback.call(params.scope || window);
                    if (params.destroyOnComplete) {
                        audio.destroy();
                    }
                };
                howl.on("end", audio._onend);
            }
            return audio;
        }

        /**
         * @param name
         * @param {object} params
         * @param {number} [params.volume=1]
         * @param {number} [params.delay=0]
         * @param {number} [params.fadeIn=0]
         * @param {function} [params.callback]
         * @param {*} [params.scope]
         */

    }, {
        key: "playMusic",
        value: function playMusic(name, params) {
            params = Object.assign({}, { volume: 1, delay: 0, fadeIn: 0 }, params);
            if (typeof name !== "string") {
                name = P3.utils.selectRandom(name);
            }

            var id = -1;

            // skip if no change
            if (this._music && this._music.howl.name === name) {
                return this._music;
            }

            var howl = this._cache[name];
            if (!howl) {
                console.warn("Could not find music - " + name);
                return null;
            }

            id = howl.play();
            howl.volume(params.volume || 1, id);
            howl.loop(true, id);

            var audio = new _Audio2.default(id, howl);
            if (params.callback) {
                audio._onend = function () {
                    params.callback.call(params.scope);
                };
                howl.on("end", audio._onend);
            }

            if ((params.fadeIn || 0) > 0) {
                if (this._music) {
                    this.fadeOut(this._music, params.fadeIn, function (audio) {
                        audio.destroy();
                    }, this);
                }
                this.fadeIn(audio, params.fadeIn);
            } else if (this._music) {
                this._music.destroy();
            }

            this._music = audio;
            return audio;
        }
    }, {
        key: "stopMusic",
        value: function stopMusic() {
            if (!this._music) return;
            this._music.destroy();
            this._music = null;
        }

        /**
         * @param {boolean} value
         */

    }, {
        key: "mute",
        value: function mute(value) {
            this._isMute = value;
            if (this._isMute) {
                Howler.mute(true);
            } else {
                Howler.mute(false);
            }
        }

        /**
         * @param {Audio} audio
         * @param {number} [duration=1]
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "fadeIn",
        value: function fadeIn(audio) {
            var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var callback = arguments[2];
            var scope = arguments[3];

            var volume = audio.howl.volume(audio.id);
            audio.howl.volume(0, audio.id);
            audio.__volume = 0;

            TweenMax.killTweensOf(audio);
            TweenMax.to(audio, duration, {
                __volume: volume,
                ease: Power1.easeInOut,
                onUpdate: function onUpdate() {
                    audio.howl.volume(audio.__volume, audio.id);
                },
                onUpdateScope: this,
                onComplete: callback,
                onCompleteParams: [audio],
                onCompleteScope: scope
            });
        }

        /**
         * @param {Audio} audio
         * @param {number} [duration=1]
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "fadeOut",
        value: function fadeOut(audio) {
            var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var callback = arguments[2];
            var scope = arguments[3];

            audio.__volume = audio.howl.volume(audio.id);

            TweenMax.killTweensOf(audio);
            TweenMax.to(audio, duration, {
                __volume: 0,
                ease: Power1.easeInOut,
                onUpdate: function onUpdate() {
                    audio.howl.volume(audio.__volume, audio.id);
                },
                onUpdateScope: this,
                onComplete: callback,
                onCompleteParams: [audio],
                onCompleteScope: scope
            });
        }

        /**
         * @returns {Audio}
         */

    }, {
        key: "music",
        get: function get() {
            return this._music;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "isMute",
        get: function get() {
            return this._isMute;
        }
    }]);

    return AudioManager;
}();

exports.default = AudioManager;

},{"./Audio":2}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Audio = require("./Audio");

Object.defineProperty(exports, "Audio", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Audio).default;
  }
});

var _AudioManager = require("./AudioManager");

Object.defineProperty(exports, "AudioManager", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AudioManager).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./Audio":2,"./AudioManager":3}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf p3.camera
 */
var Camera = function () {
    /**
     * @param {PIXI.Point} [view]
     * @param {boolean} [snapToPixel]
     */
    function Camera(view) {
        var snapToPixel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _classCallCheck(this, Camera);

        /**
         * @member {Object}
         * @member {signals.Signal} signals.trackStart
         * @member {signals.Signal} signals.trackStop
         */
        this.signals = {
            trackStart: new signals.Signal(),
            trackStop: new signals.Signal()
        };

        /**
         * @member {PIXI.Point}
         */
        this.view = view || new PIXI.Point();

        /**
         * @member {PIXI.Rectangle}
         */
        this.bounds = new PIXI.Rectangle(-(Number.MAX_SAFE_INTEGER * 0.5), -(Number.MAX_SAFE_INTEGER * 0.5), Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);

        /**
         * @member {PIXI.Point}
         */
        this.offset = new PIXI.Point();

        /**
         * @member {boolean}
         */
        this.snapToPixel = snapToPixel;

        /**
         * @member {PIXI.Point}
         * @private
         */
        this._position = new PIXI.Point();

        /**
         * @member {*}
         * @private
         */
        this._target = null;

        /**
         * @member {Array.<CameraLayer>}
         * @private
         */
        this._layers = [];

        /**
         * @member {PIXI.Point}
         * @private
         */
        this._ease = new PIXI.Point(0.2, 0.2);

        /**
         * @member {PIXI.Point}
         * @private
         */
        this._parallax = new PIXI.Point(1, 1);

        /**
         * @member {boolean}
         * @private
         */
        this._tracking = false;
    }

    /**
     */


    _createClass(Camera, [{
        key: "destroy",
        value: function destroy() {
            this.signals.trackStart.dispose();
            this.signals.trackStop.dispose();

            this.removeAllLayers();
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            var pos = this._target ? new PIXI.Point(this._target.x + this.offset.x, this._target.y + this.offset.y) : new PIXI.Point();

            this._clampToBounds(pos);

            if (this._shakeTime > 0) {
                pos.x += this._shakeStrength * P3.math.randomInt(-1, 1) * (this._shakeTime / this._shakeDuration);
                pos.y += this._shakeStrength * P3.math.randomInt(-1, 1) * (this._shakeTime / this._shakeDuration);
                this._shakeTime = Math.max(0, this._shakeTime - dt);
            }

            var dx = pos.x - this._position.x * this._parallax.x;
            var dy = pos.y - this._position.y * this._parallax.y;

            this._position.x += dx * (this._ease.x * (1 / this._parallax.x));
            this._position.y += dy * (this._ease.y * (1 / this._parallax.y));

            if (Math.abs(dx) < 0.01) this._position.x = pos.x;
            if (Math.abs(dy) < 0.01) this._position.y = pos.y;

            if (this.snapToPixel) {
                this._position.x = Math.round(this._position.x);
                this._position.y = Math.round(this._position.y);
            }

            var d = dx * dx + dy * dy;
            if (d < 0.1 && !this._tracking) {
                this._tracking = true;
                this.signals.trackStop.dispatch(this);
            } else if (d > 0.1 && this._tracking) {
                this._tracking = false;
                this.signals.trackStart.dispatch(this);
            }
            this.updateLayers();
        }

        /**
         */

    }, {
        key: "updateLayers",
        value: function updateLayers() {
            for (var i = 0; i < this._layers.length; ++i) {
                var layer = this._layers[i];
                layer.view.x = this._position.x * -layer.parallax.x + this.view.x - this.view.x * (1 - layer.parallax.x);
                layer.view.y = this._position.y * -layer.parallax.y + this.view.y - this.view.y * (1 - layer.parallax.y);
            }
        }

        /**
         * @param {...CameraLayer} layer - The layer(s) to add to the camera.
         * @returns {CameraLayer} The first layer that was added.
         */

    }, {
        key: "addLayer",
        value: function addLayer(layer) {
            var len = arguments.length;
            if (len > 1) {
                for (var i = 0; i < len; ++i) {
                    this._layers.push(arguments[i]);
                }
            } else {
                this._layers.push(layer);
            }

            this.updateLayers();
            return layer;
        }

        /**
         * @param {...CameraLayer} layer - The layer(s) to remove from the camera.
         * @returns {CameraLayer} The first layer that was added.
         */

    }, {
        key: "removeLayer",
        value: function removeLayer(layer) {
            var len = arguments.length;
            if (len > 1) {
                for (var i = len - 1; i >= 0; --i) {
                    this.removeLayer(arguments[i]);
                }
            } else {
                var _i = this._layers.indexOf(layer);
                if (_i !== -1) {
                    this._layers.splice(_i, 1);
                } else {
                    throw new Error("Layer does not exit!");
                }
            }
            return layer;
        }

        /**
         */

    }, {
        key: "removeAllLayers",
        value: function removeAllLayers() {
            this._layers = [];
        }

        /**
         * @param {*} target
         * @param {boolean} [reset=false]
         */

    }, {
        key: "setTarget",
        value: function setTarget(target) {
            var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this._target = target;

            var layer = this.findLayer(this._target, true);
            this._parallax.x = layer ? layer.parallax.x : 1;
            this._parallax.y = layer ? layer.parallax.y : 1;

            if (reset) {
                var pos = this._target ? new PIXI.Point(this._target.x + this.offset.x, this._target.y + this.offset.y) : this._position.clone();

                this._clampToBounds(pos);
                this._position.x = pos.x;
                this._position.y = pos.y;
                this.updateLayers();
            }
        }

        /**
         * @param {number} duration
         * @param {number} strength
         */

    }, {
        key: "shake",
        value: function shake(duration, strength) {
            this._shakeTime = this._shakeDuration = duration;
            this._shakeStrength = strength;
        }

        /**
         * @param {PIXI.DisplayObject} displayObject
         * @param {boolean} [recursive=false]
         */

    }, {
        key: "findLayer",
        value: function findLayer(displayObject) {
            var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var result = null;
            for (var i = 0; i < this._layers.length; ++i) {
                var layer = this._layers[i];
                if (layer.view === displayObject || searchChildren.call(this, layer.view, recursive)) {
                    result = layer;
                }
            }
            function searchChildren(displayObject, recursive) {
                for (var _i2 = 0; _i2 < displayObject.children.length; ++_i2) {
                    var child = displayObject.children[_i2];
                    if (child === displayObject) {
                        return true;
                    } else if (recursive) {
                        searchChildren.call(this, child, recursive);
                    }
                }
                return false;
            }

            return result;
        }

        /**
         * @param position
         * @returns {PIXI.Point}
         * @private
         */

    }, {
        key: "_clampToBounds",
        value: function _clampToBounds(position) {
            if (position.x < this.bounds.x) {
                position.x = this.bounds.x;
            } else if (position.x > this.bounds.width) {
                position.x = this.bounds.width;
            }
            if (position.y < this.bounds.y) {
                position.y = this.bounds.y;
            } else if (position.y > this.bounds.height) {
                position.y = this.bounds.height;
            }
        }

        /**
         * @returns {PIXI.Point}
         */

    }, {
        key: "position",
        get: function get() {
            return this._position;
        }

        /**
         * @returns {*}
         */

    }, {
        key: "target",
        get: function get() {
            return this._target;
        }

        /**
         * @returns {PIXI.Point}
         */

    }, {
        key: "ease",
        get: function get() {
            return this._ease;
        }

        /**
         * @param {PIXI.Point} value
         */
        ,
        set: function set(value) {
            this._ease = value;
        }

        /**
         * @returns {Array.<CameraLayer>}
         */

    }, {
        key: "layers",
        get: function get() {
            return this._layers.slice(0);
        }
    }]);

    return Camera;
}();

exports.default = Camera;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf p3.camera
 */
var CameraLayer = function () {
  /**
   * @param {PIXI.Container} view
   * @param {PIXI.Point} [parallax]
   */
  function CameraLayer(view, parallax) {
    _classCallCheck(this, CameraLayer);

    /**
     * @type {PIXI.Container}
     * @private
     */
    this._view = view;

    /**
     * @type {PIXI.Point}
     * @private
     */
    this._parallax = parallax || new PIXI.Point();
  }

  /**
   * @returns {PIXI.Container}
   */


  _createClass(CameraLayer, [{
    key: "view",
    get: function get() {
      return this._view;
    }

    /**
     * @returns {PIXI.Point}
     */

  }, {
    key: "parallax",
    get: function get() {
      return this._parallax;
    }
  }]);

  return CameraLayer;
}();

exports.default = CameraLayer;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Camera = require("./Camera");

Object.defineProperty(exports, "Camera", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Camera).default;
  }
});

var _CameraLayer = require("./CameraLayer");

Object.defineProperty(exports, "CameraLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CameraLayer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./Camera":5,"./CameraLayer":6}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3
 */
var AssetManager = function () {
    function AssetManager() {
        _classCallCheck(this, AssetManager);

        /**
         * @type {Object}
         */
        this.signals = {};

        /**
         * @type {signals.Signal}
         */
        this.signals.progress = new signals.Signal();

        /**
         * @type {signals.Signal}
         */
        this.signals.complete = new signals.Signal();

        /**
         * @type {signals.Signal}
         */
        this.signals.error = new signals.Signal();

        /**
         * @type {PIXI.loaders.Loader}
         * @private
         */
        this._loader = new PIXI.loaders.Loader();
        this._loader.on("progress", this._onLoaderProgress, this);
        this._loader.on("complete", this._onLoaderComplete, this);
        this._loader.on("error", this._onLoaderError, this);

        /**
         * @type {Array}
         * @private
         */
        this._manifest = [];

        /**
         * @type {Object}
         * @private
         */
        this._resources = {};

        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x0, 0.5);
        graphics.drawRect(0, 0, 100, 100);
        graphics.endFill();
        graphics.lineStyle(2, 0xFF0000, 1);
        graphics.moveTo(0, 0);
        graphics.lineTo(100, 100);
        graphics.moveTo(100, 0);
        graphics.lineTo(0, 100);

        try {
            this._fallbackTexture = graphics.generateTexture();
        } catch (e) {
            this._fallbackTexture = PIXI.Texture.EMPTY;
        }
    }

    /**
     * @param {Array} files
     * @param {string} [path]
     * @returns {Array}
     */


    _createClass(AssetManager, [{
        key: "addFiles",
        value: function addFiles(files) {
            var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            if (path && path.length > 0) {
                for (var i = 0; i < files.length; ++i) {
                    var url = files[i].url;
                    files[i].url = path + url;
                }
            }
            this._manifest = this._manifest.concat(files);
            return this._manifest;
        }

        /**
         */

    }, {
        key: "load",
        value: function load() {
            if (!this._manifest.length) return;

            this._loader.add(this._manifest);
            this._loader.load();
            return this._manifest;
        }

        /**
         * @param {string} name
         * @param {string} [extension]
         */

    }, {
        key: "unloadTexture",
        value: function unloadTexture(name, extension) {
            extension = "." + (extension || "png");

            var resource = this._resources[name];
            var split = resource.url.split(".");
            var texture = PIXI.utils.TextureCache[split[0] + extension];
            texture.destroy(true);
        }

        /**
         * @param {string} name
         * @param {string} [extension]
         */

    }, {
        key: "texture",
        value: function texture(name, extension) {
            extension = "." + (extension || "png");

            var texture = void 0;
            try {
                texture = PIXI.Texture.fromFrame(name + extension);
            } catch (error) {
                if (this._resources[name]) {
                    texture = this._resources[name].texture;
                } else {
                    console.warn("texture not found : " + name);
                    texture = this._fallbackTexture;
                }
            }
            return texture;
        }

        /**
         * @param {string} name
         * @returns {Object}
         */

    }, {
        key: "json",
        value: function json(name) {
            var data = P3.utils.copyObject(this._resources[name].data);
            if (!data) {
                throw new Error("json not found: " + name);
            }
            return data;
        }

        /**
         * @param {string} name
         * @returns {Object}
         */

    }, {
        key: "spineData",
        value: function spineData(name) {
            var resource = this._resources[name];
            if (!resource || resource && !resource.spineData) {
                throw new Error("spine data not found: " + name);
            }
            return resource.spineData;
        }

        /**
         * @param {PIXI.loaders.Loader} loader
         * @param {*} resource
         * @private
         */

    }, {
        key: "_onLoaderProgress",
        value: function _onLoaderProgress(loader, resource) {
            this.signals.progress.dispatch(loader, resource, loader.progress);
        }

        /**
         * @param {PIXI.loaders.Loader} loader
         * @param {Array.<*>} resources
         * @private
         */

    }, {
        key: "_onLoaderComplete",
        value: function _onLoaderComplete(loader, resources) {
            for (var i in resources) {
                if (resources.hasOwnProperty(i)) {
                    this._resources[i] = resources[i];
                }
            }
            this._manifest.length = 0;
            this._loader.reset();

            this.signals.complete.dispatch(loader, resources);
        }

        /**
         * @param {string} error
         * @param {PIXI.loaders.Loader} loader
         * @param {Array<*>} resource
         * @private
         */

    }, {
        key: "_onLoaderError",
        value: function _onLoaderError(error, loader, resource) {
            this.signals.error.dispatch(error, loader, resource);
        }

        /**
         * @returns {Object}
         */

    }, {
        key: "manifest",
        get: function get() {
            return this._manifest.slice();
        }
    }]);

    return AssetManager;
}();

exports.default = AssetManager;

},{}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ButtonStates = require("./ButtonStates");

var _ButtonStates2 = _interopRequireDefault(_ButtonStates);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
var Button = function (_PIXI$Container) {
    _inherits(Button, _PIXI$Container);

    /**
     * @param {ButtonStates} states
     */
    function Button(states) {
        _classCallCheck(this, Button);

        /**
         * @member {Object}
         * @member {signals.Signal} down
         * @member {signals.Signal} up
         * @member {signals.Signal} over
         * @member {signals.Signal} out
         * @member {signals.Signal} click
         * @member {signals.Signal} animate
         */
        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));

        _this.signals = {
            down: new signals.Signal(),
            up: new signals.Signal(),
            over: new signals.Signal(),
            out: new signals.Signal(),
            click: new signals.Signal(),
            animate: new signals.Signal(),
            focus: new signals.Signal(),
            unfocus: new signals.Signal()
        };

        /**
         * @member {boolean}
         */
        _this.animate = true;

        /**
         * @member {boolean}
         */
        _this.animateIcon = true;

        /**
         * @member {PIXI.Point}
         */
        _this.defaultScale = new PIXI.Point(1, 1);

        /**
         * @member {PIXI.Point}
         */
        _this.animateOverScale = new PIXI.Point(1.1, 1.1);

        /**
         * @member {PIXI.Point}
         */
        _this.animateDownScale = new PIXI.Point(0.9, 0.9);

        /**
         * @member {string}
         */
        _this.upSoundName = null;

        /**
         * @member {string}
         */
        _this.overSoundName = null;

        /**
         * @member {string}
         */
        _this.downSoundName = null;

        /**
         * @member {string}
         */
        _this.clickSoundName = null;

        /**
         * @member {ButtonStates}
         * @protected
         */
        _this._states = states;

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._background = new PIXI.Sprite(_this._states.normal);
        _this._background.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(_this._background);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._icon = new PIXI.Sprite(_this._states.icon || PIXI.Texture.EMPTY);
        _this._icon.anchor = new PIXI.Point(0.5, 0.5);
        _this.addChild(_this._icon);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._focus = new PIXI.Sprite(_this._states.focus || PIXI.Texture.EMPTY);
        _this._focus.anchor = new PIXI.Point(0.5, 0.5);
        _this._focus.visible = false;
        _this.addChild(_this._focus);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._shortcutIcon = new PIXI.Sprite(PIXI.Texture.EMPTY);
        _this._shortcutIcon.anchor = new PIXI.Point(0.5, 0.5);
        _this._shortcutIcon.visible = !_ismobilejs2.default.any;
        _this._background.addChild(_this._shortcutIcon);

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentNormalTexture = _this._states.normal;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentOverTexture = _this._states.over;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentDownTexture = _this._states.down;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentIconTexture = _this._states.icon;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentIconOverTexture = _this._states.iconOver;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentIconDownTexture = _this._states.iconDown;

        /**
         * @member {TweenMax}
         * @protected
         */
        _this._tweenOver = null;

        /**
         * @member {TweenMax}
         * @protected
         */
        _this._tweenOut = null;

        /**
         * @member {TweenMax}
         * @protected
         */
        _this._tweenDown = null;

        /**
         * @member {boolean}
         * @protected
         */
        _this._enabled = true;

        /**
         * @member {boolean}
         * @private
         */
        _this._focused = false;

        _this.interactive = true;
        _this.buttonMode = true;
        _this.mousedown = _this.touchstart = _this._onMouseDown.bind(_this);
        _this.mouseup = _this.touchend = _this._onMouseUp.bind(_this);
        _this.mouseupoutside = _this.touchendoutside = _this._onMouseOut.bind(_this);
        _this.click = _this.tap = _this._onMouseClick.bind(_this);
        _this.mouseover = _this._onMouseOver.bind(_this);
        _this.mouseout = _this._onMouseOut.bind(_this);
        return _this;
    }

    /**
     * @param {PIXI.Texture} normal
     * @param {PIXI.Texture} [over]
     * @param {PIXI.Texture} [down]
     * @param {PIXI.Texture} [icon]
     */


    _createClass(Button, [{
        key: "destroy",


        /**
         */
        value: function destroy() {
            TweenMax.killTweensOf(this);
            TweenMax.killTweensOf(this.scale);

            this.signals.up.dispose();
            this.signals.down.dispose();
            this.signals.over.dispose();
            this.signals.out.dispose();
            this.signals.click.dispose();
            this.signals.animate.dispose();
            this.signals.focus.dispose();
            this.signals.unfocus.dispose();

            _get(Button.prototype.__proto__ || Object.getPrototypeOf(Button.prototype), "destroy", this).call(this, { children: true });
        }
    }, {
        key: "focus",
        value: function focus() {
            this._focused = true;
            this._focus.visible = true;
            this.signals.focus.dispatch(this);
        }
    }, {
        key: "unfocus",
        value: function unfocus() {
            this._focused = false;
            this._focus.visible = false;
            this.signals.unfocus.dispatch(this);
        }

        /**
         * @param {PIXI.Texture} texture
         * @param {PIXI.Point} offset
         */

    }, {
        key: "setShortcutIcon",
        value: function setShortcutIcon(texture, offset) {
            this._shortcutIcon.texture = texture;
            this._shortcutIcon.position.set(offset.x, offset.y);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "_onMouseDown",
        value: function _onMouseDown(event) {
            this._states.down && (this._background.texture = this._currentDownTexture);
            this._states.iconDown && (this._icon.texture = this._currentIconDownTexture);

            if (this.animate) {
                var tweens = TweenMax.getTweensOf(this, true);
                var a = tweens.indexOf(this._tweenOver) > -1 ? tweens.length - 1 : tweens.length;
                if (!a) {
                    if (this._tweenOver) {
                        this._tweenOver.kill();
                        this._tweenOver = null;
                    }
                    this._tweenDown = this.animateDown();
                }
            }
            Button.audio && this.downSoundName && Button.audio.playSound(this.downSoundName);
            this._enabled && this.signals.down.dispatch(this, event);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "_onMouseUp",
        value: function _onMouseUp(event) {
            this._background.texture = this._states.over && !_ismobilejs2.default.any ? this._currentOverTexture : this._currentNormalTexture;
            if (this._states.iconOver && !_ismobilejs2.default.any) {
                this._icon.texture = this._currentIconOverTexture;
            } else if (this._states.icon) {
                this._icon.texture = this._currentIconTexture;
            }
            if (this.animate && this._tweenDown) {
                if (this._tweenDown) {
                    this._tweenDown.kill();
                    this._tweenDown = null;
                }
                this._tweenOver = !_ismobilejs2.default.any ? this.animateOver() : this.animateOut();
            }
            Button.audio && this.upSoundName && Button.audio.playSound(this.upSoundName);
            this._enabled && this.signals.up.dispatch(this, event);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "_onMouseOver",
        value: function _onMouseOver(event) {
            this._states.over && (this._background.texture = this._currentOverTexture);
            this._states.iconOver && (this._icon.texture = this._currentIconOverTexture);

            if (this.animate && !_ismobilejs2.default.any) {
                var tweens = TweenMax.getTweensOf(this, true);
                if (tweens.indexOf(this._tweenOver) === -1) {
                    if (this._tweenOut) {
                        this._tweenOut.kill();
                        this._tweenOut = null;
                    }
                    this._tweenOver = this.animateOver();
                }
            }
            if (this.animateIcon && !_ismobilejs2.default.any) {
                TweenMax.killTweensOf(this._icon.scale);
                TweenMax.to(this._icon.scale, 0.8, {
                    x: 1.2,
                    y: 1.2,
                    ease: Elastic.easeOut,
                    easeParams: [1.6]
                });
            }
            Button.audio && this.overSoundName && Button.audio.playSound(this.overSoundName);
            this._enabled && this.signals.over.dispatch(this, event);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "_onMouseOut",
        value: function _onMouseOut(event) {
            this._background.texture = this._currentNormalTexture;
            this._states.icon && (this._icon.texture = this._currentIconTexture);

            if (this._tweenOver || this._tweenDown) {
                var tweens = TweenMax.getTweensOf(this, true);
                if (tweens.indexOf(this._tweenOut) === -1) {
                    if (this._tweenOver) {
                        this._tweenOver.kill();
                        this._tweenOver = null;
                    }
                    this._tweenOut = this.animateOut();
                }
                if (tweens.indexOf(this._tweenDown) === -1) {
                    if (this._tweenDown) {
                        this._tweenDown.kill();
                        this._tweenDown = null;
                    }
                    this._tweenOut = this.animateOut();
                }
            }
            TweenMax.killTweensOf(this._icon.scale);
            TweenMax.to(this._icon.scale, 0.34, {
                x: 1,
                y: 1,
                ease: Power1.easeInOut
            });
            Button.audio && this.upSoundName && Button.audio.playSound(this.upSoundName);
            this._enabled && this.signals.out.dispatch(this, event);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "_onMouseClick",
        value: function _onMouseClick(event) {
            Button.audio && this.clickSoundName && Button.audio.playSound(this.clickSoundName);
            this._enabled && this.signals.click.dispatch(this, event);
        }

        /**
         * @returns {TweenMax}
         */

    }, {
        key: "animateOver",
        value: function animateOver() {
            return TweenMax.to(this.scale, 0.6, {
                x: this.defaultScale.x * this.animateOverScale.x,
                y: this.defaultScale.y * this.animateOverScale.y,
                ease: Elastic.easeOut,
                easeParams: [1],
                onComplete: function onComplete() {
                    this.signals.animate.dispatch(this, "over");
                },
                onCompleteScope: this
            });
        }
    }, {
        key: "animateOut",


        /**
         * @returns {TweenMax}
         */
        value: function animateOut() {
            return TweenMax.to(this.scale, 0.3, {
                x: this.defaultScale.x,
                y: this.defaultScale.y,
                ease: Back.easeInOut,
                easeParams: [2],
                onComplete: function onComplete() {
                    this.signals.animate.dispatch(this, "out");
                },
                onCompleteScope: this
            });
        }
    }, {
        key: "animateDown",


        /**
         * @returns {TweenMax}
         */
        value: function animateDown() {
            return TweenMax.to(this.scale, 0.14, {
                x: this.defaultScale.x * this.animateDownScale.x,
                y: this.defaultScale.y * this.animateDownScale.y,
                ease: Back.easeOut,
                easeParams: [1],
                onComplete: function onComplete() {
                    this.signals.animate.dispatch(this, "down");
                },
                onCompleteScope: this
            });
        }
    }, {
        key: "stopAnimations",


        /**
         */
        value: function stopAnimations() {
            var tweens = TweenMax.getTweensOf(this, true);
            if (tweens.indexOf(this._tweenOver) === -1) {
                if (this._tweenOut) {
                    this._tweenOut.kill();
                    this._tweenOut = null;
                }
                this._tweenOver = this.animateOver();
            }
            if (tweens.indexOf(this._tweenOut) === -1) {
                if (this._tweenOver) {
                    this._tweenOver.kill();
                    this._tweenOver = null;
                }
            }
            if (tweens.indexOf(this._tweenDown) === -1) {
                if (this._tweenDown) {
                    this._tweenDown.kill();
                    this._tweenDown = null;
                }
            }
        }
    }, {
        key: "setStates",


        /**
         * @param {P3.ButtonStates} states
         */
        value: function setStates(states) {
            this._states = states;
            this._background.texture = this._states.normal;
            this._icon.texture = this._states.icon;

            this._currentNormalTexture = this._states.normal;
            this._currentOverTexture = this._states.over;
            this._currentDownTexture = this._states.down;
            this._currentIconTexture = this._states.icon;
            this._currentIconOverTexture = this._states.iconOver;
            this._currentIconDownTexture = this._states.iconDown;
        }

        /**
         * @returns {ButtonStates}
         */

    }, {
        key: "states",
        get: function get() {
            return this._states;
        }

        /**
         * @returns {PIXI.Texture}
         */

    }, {
        key: "currentNormalTexture",
        get: function get() {
            return this._currentNormalTexture;
        }

        /**
         * @returns {PIXI.Texture}
         */

    }, {
        key: "currentOverTexture",
        get: function get() {
            return this._currentOverTexture;
        }

        /**
         * @returns {PIXI.Texture}
         */

    }, {
        key: "currentDownTexture",
        get: function get() {
            return this._currentDownTexture;
        }

        /**
         * @returns {PIXI.Texture}
         */

    }, {
        key: "currentIconTexture",
        get: function get() {
            return this._currentIconTexture;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "enabled",
        get: function get() {
            return this._enabled;
        }

        /**
         * @param {boolean} value
         */
        ,
        set: function set(value) {
            this._enabled = value;
            this._currentNormalTexture = value || !this._states.normalInactive ? this._states.normal : this._states.normalInactive;
            this._currentOverTexture = value || !this._states.overInactive ? this._states.over : this._states.overInactive;
            this._currentDownTexture = value || !this._states.downInactive ? this._states.down : this._states.downInactive;
            this._currentIconTexture = value || !this._states.iconInactive ? this._states.icon : this._states.iconInactive;
            this._currentIconOverTexture = value || !this._states.iconOverInactive ? this._states.iconOver : this._states.iconOverInactive;
            this._currentIconDownTexture = value || !this._states.iconDownInactive ? this._states.iconDown : this._states.iconDownInactive;

            this._currentNormalTexture && (this._background.texture = this._currentNormalTexture);
            this._currentIconTexture && (this._icon.texture = this._currentIconTexture);
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "focused",
        get: function get() {
            return this._focused;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "tint",
        get: function get() {
            return this._background.tint;
        }

        /**
         * @param {number} value
         */
        ,
        set: function set(value) {
            this._background.tint = value;
            this._icon.tint = value;
        }
    }], [{
        key: "create",
        value: function create(normal, over, down, icon) {
            var states = new _ButtonStates2.default(normal, over, down, icon);
            return new Button(states);
        }
    }]);

    return Button;
}(PIXI.Container);

exports.default = Button;

},{"./ButtonStates":11,"ismobilejs":1}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  ButtonManager
 *
 *  Created by legman on 15/08/2017.
 *
 */

/**
 * @class
 * @namespace P3
 */
var ButtonManager = function () {
    /**
     * @param {P3.Input} input
     */
    function ButtonManager(input) {
        _classCallCheck(this, ButtonManager);

        /**
         * @member {P3.Input}
         * @private
         */
        this._input = input;

        /**
         * @member {Array.<P3.Button>}
         * @private
         */
        this._buttons = [];

        /**
         * @member {P3.Button}
         * @private
         */
        this._currentFocus = null;

        // todo finish this class at some point
    }

    /**
     * @param {P3.Button} button
     */


    _createClass(ButtonManager, [{
        key: "add",
        value: function add(button) {
            if (this._buttons.indexOf(button) !== -1) return;
            this._buttons.push(button);
        }

        /**
         * @param button
         */

    }, {
        key: "remove",
        value: function remove(button) {
            var i = this._buttons.indexOf(button);
            this._buttons.splice(i, 1);
        }
    }, {
        key: "update",
        value: function update() {
            if (this._input.isKeyPressed(37)) {
                this._selectLeft();
            }
            if (this._input.isKeyPressed(39)) {
                this._selectRight();
            }
            if (this._input.isKeyPressed(38)) {
                this._selectUp();
            }
            if (this._input.isKeyPressed(40)) {
                this._selectDown();
            }
        }

        /**
         * @param {P3.Button} button
         */

    }, {
        key: "focus",
        value: function focus(button) {
            for (var i = 0; i < this._buttons.length; ++i) {
                var _button = this._buttons[i];
                _button.tint = 0xFFFFFF;
            }
            button.tint = 0xFF0000;
            this._currentFocus = button;
        }

        /**
         * @private
         */

    }, {
        key: "_selectLeft",
        value: function _selectLeft() {
            console.log("left");
        }

        /**
         * @private
         */

    }, {
        key: "_selectRight",
        value: function _selectRight() {
            console.log("right");
        }

        /**
         * @private
         */

    }, {
        key: "_selectUp",
        value: function _selectUp() {
            console.log("up");
        }

        /**
         * @private
         */

    }, {
        key: "_selectDown",
        value: function _selectDown() {
            console.log("down");
        }
    }]);

    return ButtonManager;
}();

exports.default = ButtonManager;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
var ButtonStates = function () {
  /**
   * @param {PIXI.Texture} normal
   * @param {PIXI.Texture} [over]
   * @param {PIXI.Texture} [down]
   * @param {PIXI.Texture} [icon]
   */
  function ButtonStates(normal, over, down, icon) {
    _classCallCheck(this, ButtonStates);

    /**
     * @member {PIXI.Texture}
     */
    this.normal = normal;

    /**
     * @member {PIXI.Texture}
     */
    this.over = over || null;

    /**
     * @member {PIXI.Texture}
     */
    this.down = down || null;

    /**
     * @member {PIXI.Texture}
     */
    this.focus = null;

    /**
     * @member {PIXI.Texture}
     */
    this.icon = icon || null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconOver = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconDown = null;

    /**
     * @member {PIXI.Texture}
     */
    this.normalAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.overAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.downAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconOverAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconDownAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.normalInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.overInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.downInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconOverInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconDownInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.normalInactiveAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.overInactiveAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.downInactiveAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconInactiveAlt = null;
  }

  /**
   * @returns {ButtonStates}
   */


  _createClass(ButtonStates, [{
    key: "clone",
    value: function clone() {
      var states = new ButtonStates(this.normal);
      states.over = this.over;
      states.down = this.down;
      states.over = this.over;
      states.focus = this.focus;
      states.icon = this.icon;
      states.iconOver = this.iconOver;
      states.iconDown = this.iconDown;
      states.normalAlt = this.normalAlt;
      states.downAlt = this.downAlt;
      states.overAlt = this.overAlt;
      states.iconAlt = this.iconAlt;
      states.iconOverAlt = this.iconOverAlt;
      states.iconDownAlt = this.iconDownAlt;
      states.normalInactive = this.normalInactive;
      states.downInactive = this.downInactive;
      states.overInactive = this.overInactive;
      states.iconInactive = this.iconInactive;
      states.iconDownInactive = this.iconDownInactive;
      states.iconOverInactive = this.iconOverInactive;
      states.normalInactiveAlt = this.normalInactiveAlt;
      states.downInactiveAlt = this.downInactiveAlt;
      states.overInactiveAlt = this.overInactiveAlt;
      states.iconInactiveAlt = this.iconInactiveAlt;
      return states;
    }
  }]);

  return ButtonStates;
}();

exports.default = ButtonStates;

},{}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Vector = require("../math/Vector2");

var _Vector2 = _interopRequireDefault(_Vector);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3
 */
var Input = function () {
    function Input() {
        _classCallCheck(this, Input);

        /**
         * @member {Object} signals
         * @member {signals.Signal} signals.mouseMove
         * @member {signals.Signal} signals.mouseDown
         * @member {signals.Signal} signals.mouseUp
         * @member {signals.Signal} signals.mouseClick
         * @member {signals.Signal} signals.keyDown
         * @member {signals.Signal} signals.keyUp
         * @member {signals.Signal} signals.swipeLeft
         * @member {signals.Signal} signals.swipeRight
         * @member {signals.Signal} signals.swipeUp
         * @member {signals.Signal} signals.swipeDown
         * @member {signals.Signal} signals.orientation
         */
        this.signals = {
            mouseMove: new signals.Signal(),
            mouseDown: new signals.Signal(),
            mouseUp: new signals.Signal(),
            mouseClick: new signals.Signal(),
            keyDown: new signals.Signal(),
            keyUp: new signals.Signal(),
            swipeLeft: new signals.Signal(),
            swipeRight: new signals.Signal(),
            swipeUp: new signals.Signal(),
            swipeDown: new signals.Signal(),
            orientation: new signals.Signal()
        };

        /**
         * @member {PIXI.DisplayObject}
         * @private
         */
        this._stage = null;

        /**
         * @member {Object}
         * @private
         */
        this._keyMap = {};

        /**
         * @member {Object}
         * @private
         */
        this._keyBuffer = {};

        /**
         * @member {PIXI.Point}
         * @private
         */
        this._touch = null;

        /**
         * @type {null}
         * @private
         */
        this._swipeStart = null;

        /**
         * @type {number}
         * @private
         */
        this._swipeTime = 0;

        /**
         * @member {Object} orientation
         * @member {number} orientation.gamma
         * @member {number} orientation.beta
         * @member {number} orientation.alpha
         * @private
         */
        this._orientation = {
            gamma: 0,
            beta: 0,
            alpha: 0
        };
    }

    /**
     * @param {PIXI.DisplayObject} stage
     * @param {*} keyListener
     */


    _createClass(Input, [{
        key: "init",
        value: function init(stage, keyListener) {
            this._stage = stage;
            this._stage.interactive = true;
            this._stage.mousemove = this._stage.touchmove = this._onMouseMove.bind(this);
            this._stage.mousedown = this._stage.touchstart = this._onMouseDown.bind(this);
            this._stage.mouseup = this._stage.touchend = this._onMouseUp.bind(this);
            this._stage.click = this._stage.tap = this._onMouseClick.bind(this);

            keyListener.onkeydown = this._onKeyDown.bind(this);
            keyListener.onkeyup = this._onKeyUp.bind(this);
            keyListener.focus();

            document.onclick = function () {
                keyListener.focus();
            };

            _ismobilejs2.default.any && window.addEventListener("deviceorientation", this._onDeviceOrientation.bind(this));
        }

        /**
         */

    }, {
        key: "destroy",
        value: function destroy() {
            this._stage.mousemove = this._stage.touchmove = null;
            this._stage.mousedown = this._stage.touchstart = null;
            this._stage.mouseup = this._stage.touchend = null;
            this._stage.click = this._stage.tap = null;

            _ismobilejs2.default.any && window.removeEventListener("deviceorientation", this._onDeviceOrientation);

            this.signals.mouseMove.dispose();
            this.signals.mouseDown.dispose();
            this.signals.mouseUp.dispose();
            this.signals.mouseClick.dispose();

            this.signals.keyDown.dispose();
            this.signals.keyUp.dispose();

            this.signals.swipeLeft.dispose();
            this.signals.swipeRight.dispose();
            this.signals.swipeUp.dispose();
            this.signals.swipeDown.dispose();

            this.signals.orientation.dispose();
        }

        /**
         */

    }, {
        key: "update",
        value: function update() {
            for (var i in this._keyBuffer) {
                if (this._keyBuffer.hasOwnProperty(i)) {
                    this._keyBuffer[i] = false;
                }
            }
        }

        /**
         * @param {number} keyCode
         * @returns {boolean}
         */

    }, {
        key: "isKeyDown",
        value: function isKeyDown(keyCode) {
            return this._keyMap[keyCode] === true;
        }

        /**
         * @param {number} keyCode
         * @returns {boolean}
         */

    }, {
        key: "isKeyPressed",
        value: function isKeyPressed(keyCode) {
            return this._keyBuffer[keyCode] === true;
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onMouseMove",
        value: function _onMouseMove(event) {
            this._touch && (this._touch = event.data.getLocalPosition(this._stage));

            this.signals.mouseMove.dispatch(event);
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onMouseDown",
        value: function _onMouseDown(event) {
            this._touch = event.data.getLocalPosition(this._stage);

            if (_ismobilejs2.default.any) {
                this._swipeStart = this._touch.clone();
                this._swipeTime = window.performance.now();
            }
            this.signals.mouseDown.dispatch(event);
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onMouseUp",
        value: function _onMouseUp(event) {
            if (_ismobilejs2.default.any) {
                var swipe = new _Vector2.default(this._touch.x - this._swipeStart.x, this._touch.y - this._swipeStart.y);
                var distance = swipe.lengthSq;
                var minimum = 4 * 4;
                swipe.normalize();

                if (window.performance.now() - this._swipeTime < 800 && distance > minimum) {
                    var left = swipe.dot(new _Vector2.default(-1, 0));
                    left > 0.9 && this.signals.swipeLeft.dispatch();

                    var right = swipe.dot(new _Vector2.default(1, 0));
                    right > 0.9 && this.signals.swipeRight.dispatch();

                    var up = swipe.dot(new _Vector2.default(0, -1));
                    up > 0.9 && this.signals.swipeUp.dispatch();

                    var down = swipe.dot(new _Vector2.default(0, 1));
                    down > 0.9 && this.signals.swipeDown.dispatch();
                }
            }

            this._touch = null;
            this.signals.mouseUp.dispatch(event);
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onMouseClick",
        value: function _onMouseClick(event) {
            this.signals.mouseClick.dispatch(event);
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onKeyDown",
        value: function _onKeyDown(event) {
            if (event.keyCode === Input.keys.LEFT || event.keyCode === Input.keys.RIGHT || event.keyCode === Input.keys.UP || event.keyCode === Input.keys.DOWN || event.keyCode === Input.keys.SPACE) event.preventDefault();

            !this.isKeyDown(event.keyCode) && (this._keyBuffer[event.keyCode] = true);
            this._keyMap[event.keyCode] = true;
            this.signals.keyDown.dispatch(event);
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onKeyUp",
        value: function _onKeyUp(event) {
            if (event.keyCode === Input.keys.LEFT || event.keyCode === Input.keys.RIGHT || event.keyCode === Input.keys.UP || event.keyCode === Input.keys.DOWN || event.keyCode === Input.keys.SPACE) event.preventDefault();

            this._keyMap[event.keyCode] = false;
            this.signals.keyUp.dispatch(event);
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onDeviceOrientation",
        value: function _onDeviceOrientation(event) {
            this.signals.orientation.dispatch(event);
        }

        /**
         * @returns {PIXI.Point}
         */

    }, {
        key: "touch",
        get: function get() {
            return this._touch;
        }

        /**
         * @returns {Object} orientation
         * @returns {number} orientation.gamma
         * @returns {number} orientation.beta
         * @returns {number} orientation.alpha
         */

    }, {
        key: "orientation",
        get: function get() {
            return this._orientation;
        }
    }]);

    return Input;
}();

/**
 * @static
 * @constant
 * @type {Object}
 */


exports.default = Input;
Input.keys = {};

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.W = 87;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.A = 65;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.S = 83;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.D = 68;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.Z = 90;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.X = 88;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.C = 67;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.LEFT = 37;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.RIGHT = 39;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.UP = 38;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.DOWN = 40;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.SPACE = 32;

/**
 * @static
 * @constant
 * @type {number}
 */
Input.keys.ENTER = 13;

},{"../math/Vector2":23,"ismobilejs":1}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _MovieClipSequence = require("./MovieClipSequence");

var _MovieClipSequence2 = _interopRequireDefault(_MovieClipSequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
var MovieClip = function (_PIXI$Sprite) {
    _inherits(MovieClip, _PIXI$Sprite);

    /**
     * @param {MovieClipSequence} sequence
     * @param {string} [defaultAnimation=default]
     * @param {boolean} [autoUpdate=true]
     */
    function MovieClip(sequence) {
        var defaultAnimation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
        var autoUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _classCallCheck(this, MovieClip);

        var texture = sequence.textures[defaultAnimation] ? sequence.textures[defaultAnimation][0] : PIXI.Texture.EMPTY;
        if (!texture) {
            throw new Error("No default texture found!");
        }

        /**
         * @member {number}
         */
        var _this = _possibleConstructorReturn(this, (MovieClip.__proto__ || Object.getPrototypeOf(MovieClip)).call(this, texture));

        _this.animationSpeed = 24;

        /**
         * @member {boolean}
         */
        _this.looping = false;

        /**
         * @member {object} signals
         * @member {signals.Signal} signals.animation
         * @member {signals.Signal} signals.animationComplete
         */
        _this.signals = {
            animation: new signals.Signal(),
            animationComplete: new signals.Signal()
        };

        /**
         * @member {*}
         * @protected
         */
        _this._frames = {};

        /**
         * @member {boolean}
         * @protected
         */
        _this._playing = false;

        /**
         * @member {string}
         * @protected
         */
        _this._defaultAnimation = defaultAnimation;

        /**
         * @member {number}
         * @protected
         */
        _this._currentFrame = 0;

        /**
         * @member {number}
         * @protected
         */
        _this._lastFrame = 0;

        /**
         * @member {string}
         * @protected
         */
        _this._currentAnimationName = _this._defaultAnimation;

        /**
         * @type {boolean}
         * @protected
         */
        _this._autoUpdate = false;

        for (var i in sequence.textures) {
            if (sequence.textures.hasOwnProperty(i)) {
                _this._frames[i] = [];
                for (var j = 0; j < sequence.textures[i].length; ++j) {
                    _this._frames[i].push({
                        texture: sequence.textures[i][j],
                        callback: null,
                        scope: null
                    });
                }
            }
        }
        _this.autoUpdate = autoUpdate;
        return _this;
    }

    /**
     * @param {object} options
     * @param {boolean} [options.children=false]
     * @param {boolean} [options.texture=false]
     * @param {boolean} [options.baseTexture=false]
     */


    _createClass(MovieClip, [{
        key: "destroy",
        value: function destroy(options) {
            this.signals.animation.dispose();
            this.signals.animationComplete.dispose();

            this.autoUpdate = false;

            _get(MovieClip.prototype.__proto__ || Object.getPrototypeOf(MovieClip.prototype), "destroy", this).call(this, options);
        }

        /**
         * @param {boolean} [looping]
         */

    }, {
        key: "play",
        value: function play(looping) {
            if (typeof looping === "boolean") {
                this.looping = looping;
            }
            this._playing = true;
        }
    }, {
        key: "stop",
        value: function stop() {
            this._playing = false;
        }

        /**
         * @param {number|string} frame
         * @param {boolean} looping
         */

    }, {
        key: "gotoAndPlay",
        value: function gotoAndPlay(frame, looping) {
            if (typeof frame !== "string") {
                this._currentFrame = this._lastFrame = frame;
            } else if (this._frames[frame]) {
                this._currentFrame = this._lastFrame = 0;
                this._currentAnimationName = frame;
            }
            if (typeof looping === "boolean") {
                this.looping = looping;
            }
            this._playing = true;
        }

        /**
         * @param {number|string} frame
         */

    }, {
        key: "gotoAndStop",
        value: function gotoAndStop(frame) {
            if (typeof frame !== "string") {
                this._currentFrame = frame;
            } else if (this._frames[frame]) {
                this._currentFrame = 0;
                this._currentAnimationName = frame;
            }
            this._playing = false;

            var frames = this._frames[this._currentAnimationName];
            var round = this._currentFrame + 0.5 | 0;
            this.texture = frames[round % frames.length].texture;
        }

        /**
         * @param {number} frame
         * @param {function} callback
         * @param {*} [scope]
         * @param {string} [name=default]
         */

    }, {
        key: "addFrameScript",
        value: function addFrameScript(frame, callback, scope) {
            var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "default";

            scope = scope || window;
            if (this._frames[name]) {
                this._frames[name][frame].callback = callback;
                this._frames[name][frame].scope = callback ? scope | window : null;
            }
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            if (!this._playing || !this.getTotalFrames()) return;

            this._autoUpdate && (dt = dt / PIXI.settings.TARGET_FPMS / 1000);
            this._currentFrame += this.animationSpeed * dt;

            var frames = this._frames[this._currentAnimationName];
            var round = this._currentFrame + 0.5 | 0;
            var index = round % (frames.length + 1);

            this._currentFrame = this._currentFrame % frames.length;
            if (index > 0 && index !== this._lastFrame) {
                this._lastFrame = index;
                frames[index - 1].callback && frames[index - 1].callback.call(frames[index - 1].scope);
            }

            if (this.looping || round < frames.length) {
                this.texture = frames[round % frames.length].texture;
                if (round >= frames.length - 1) {
                    this.signals.animation.dispatch(this, this._currentAnimationName);
                }
            } else if (round >= frames.length - 1) {
                this.gotoAndStop(frames.length - 1);
                this.signals.animationComplete.dispatch(this, this._currentAnimationName);
            }
        }

        /**
         * @param {string} [name]
         * @returns {number}
         */

    }, {
        key: "getTotalFrames",
        value: function getTotalFrames(name) {
            name = name || this._defaultAnimation;
            var frames = this._frames[name];
            return frames ? frames.length : 0;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "playing",
        get: function get() {
            return this._playing;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "currentFrame",
        get: function get() {
            return this._currentFrame;
        }

        /**
         * @returns {string}
         */

    }, {
        key: "currentAnimationFrame",
        get: function get() {
            return this._currentAnimationName;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "totalFrames",
        get: function get() {
            return this.getTotalFrames();
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "autoUpdate",
        get: function get() {
            return this._autoUpdate;
        }

        /**
         * @param {boolean} value
         */
        ,
        set: function set(value) {
            var ticker = PIXI.ticker.shared;
            if (this._autoUpdate && !value) {
                ticker.remove(this.update, this);
            } else if (!this._autoUpdate && value) {
                ticker.add(this.update, this);
            }
            this._autoUpdate = value;
        }
    }]);

    return MovieClip;
}(PIXI.Sprite);

exports.default = MovieClip;

},{"./MovieClipSequence":14}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
var MovieClipSequence = function (_PIXI$Container) {
    _inherits(MovieClipSequence, _PIXI$Container);

    function MovieClipSequence(textures, name) {
        _classCallCheck(this, MovieClipSequence);

        /**
         * @type {object} textures
         */
        var _this = _possibleConstructorReturn(this, (MovieClipSequence.__proto__ || Object.getPrototypeOf(MovieClipSequence)).call(this));

        _this.textures = {};

        textures && _this.addTextures(textures, name);
        return _this;
    }

    /**
     * @param {Array.<PIXI.Texture>} textures
     * @param {string} [name]
     */


    _createClass(MovieClipSequence, [{
        key: "addTextures",
        value: function addTextures(textures, name) {
            name = name || "default";
            this.textures[name] = textures;
        }

        /**
         * @param {string} [name]
         */

    }, {
        key: "removeTextures",
        value: function removeTextures(name) {
            name = name || "default";
            this.textures[name] = null;
        }

        /**
         */

    }, {
        key: "removeAllTextures",
        value: function removeAllTextures() {
            this.textures = {};
        }
    }]);

    return MovieClipSequence;
}(PIXI.Container);

exports.default = MovieClipSequence;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Button2 = require("./Button");

var _Button3 = _interopRequireDefault(_Button2);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends P3.Button
 */
var MuteButton = function (_Button) {
    _inherits(MuteButton, _Button);

    /**
     * @param {ButtonStates} states
     */
    function MuteButton(states) {
        _classCallCheck(this, MuteButton);

        var _this = _possibleConstructorReturn(this, (MuteButton.__proto__ || Object.getPrototypeOf(MuteButton)).call(this, states));

        _this._currentIconTexture = _this.isEnabled() ? _this._states.icon : _this._states.iconAlt;
        _this._currentIconOverTexture = _this.isEnabled() ? _this._states.iconOver : _this._states.iconOverAlt;
        _this._currentIconDownTexture = _this.isEnabled() ? _this._states.iconDown : _this._states.iconDownAlt;

        _this._icon.texture = _this._states.iconOver && !_ismobilejs2.default.any ? _this._currentIconOverTexture : _this._currentIconTexture;
        return _this;
    }

    /**
     * @param {Event} event
     * @private
     */


    _createClass(MuteButton, [{
        key: "_onMouseClick",
        value: function _onMouseClick(event) {
            this._currentIconTexture = !this.isEnabled() ? this._states.icon : this._states.iconAlt;
            this._currentIconOverTexture = !this.isEnabled() ? this._states.iconOver : this._states.iconOverAlt;
            this._currentIconDownTexture = !this.isEnabled() ? this._states.iconDown : this._states.iconDownAlt;

            this._icon.texture = this._states.iconOver && !_ismobilejs2.default.any ? this._currentIconOverTexture : this._currentIconTexture;

            if (!!_Button3.default.audio) {
                _Button3.default.audio.mute(!_Button3.default.audio.isMute);
            }
            _get(MuteButton.prototype.__proto__ || Object.getPrototypeOf(MuteButton.prototype), "_onMouseClick", this).call(this, event);
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "isEnabled",
        value: function isEnabled() {
            return !!_Button3.default.audio && !_Button3.default.audio.isMute;
        }
    }]);

    return MuteButton;
}(_Button3.default);

exports.default = MuteButton;

},{"./Button":9,"ismobilejs":1}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
var Scene = function (_PIXI$Container) {
    _inherits(Scene, _PIXI$Container);

    function Scene() {
        _classCallCheck(this, Scene);

        /**
         * @member {object} signals
         * @member {signals.Signal} signals.next
         * @member {signals.Signal} signals.previous
         * @member {signals.Signal} signals.home
         * @member {signals.Signal} signals.pause
         */
        var _this = _possibleConstructorReturn(this, (Scene.__proto__ || Object.getPrototypeOf(Scene)).call(this));

        _this.signals = {
            next: new signals.Signal(),
            previous: new signals.Signal(),
            home: new signals.Signal(),
            pause: new signals.Signal()
        };

        /**
         * @member {boolean} - The scene has finished loading its required manifest.
         */
        _this.loaded = false;

        /**
         * @member {boolean} - The scene is always updated regardless of its place in the stack.
         */
        _this.alwaysUpdate = false;

        /**
         * @member {boolean} - The scene will call appear automatically.
         */
        _this.autoAppear = true;

        /**
         * @member {Array.<TweenMax|TweenLite|TimelineMax|TimelineLite>}
         * @private
         */
        _this._tweens = [];
        return _this;
    }

    /**
     * @returns {Scene}
     */


    _createClass(Scene, [{
        key: "preloader",
        value: function preloader() {
            return new Scene();
        }

        /**
         * @returns {Array}
         */

    }, {
        key: "load",
        value: function load() {
            return [];
        }
    }, {
        key: "unload",
        value: function unload() {}
        // override


        /**
         * This method is called when a scene is initialized.
         */

    }, {
        key: "init",
        value: function init() {}
        // override


        /**
         * This method is called when a scene is destroyed.
         *
         * @param options
         * @param [options.children=false]
         * @param [options.texture=false]
         * @param [options.baseTexture=false]
         */

    }, {
        key: "destroy",
        value: function destroy(options) {
            this.signals.next.dispose();
            this.signals.previous.dispose();
            this.signals.home.dispose();
            this.signals.pause.dispose();

            this.killAllTweens();

            _get(Scene.prototype.__proto__ || Object.getPrototypeOf(Scene.prototype), "destroy", this).call(this, options);
        }

        /**
         * This method is called when the device dimensions are changed.
         */

    }, {
        key: "resize",
        value: function resize() {}
        // override


        /**
         * This method is called when the scene is 'top' of the stack.
         */

    }, {
        key: "update",
        value: function update() {}
        // override


        /**
         * This method is called when the scene is shown for the first time.
         */

    }, {
        key: "appear",
        value: function appear() {
            this.animateIn();
        }

        /**
         * This method is called when the scene is shown - regardless of actual visibility.
         */

    }, {
        key: "show",
        value: function show() {}

        /**
         * This method is called when the scene is hidden - regardless of actual visibility.
         */

    }, {
        key: "hide",
        value: function hide() {}

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {}

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {}

        /**
         * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to add to the scene.
         * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was added.
         */

    }, {
        key: "addTween",
        value: function addTween(tween) {
            var len = arguments.length;
            if (len > 1) {
                for (var i = 0; i < len; ++i) {
                    this.addTween(arguments[tween]);
                }
            } else {
                if (this._tweens.indexOf(tween) === -1) {
                    this._tweens.push(tween);
                } else {
                    console.warn("Tween already added to scene!", tween);
                }
            }
            return tween;
        }

        /**
         * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to remove from the scene.
         * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was removed.
         */

    }, {
        key: "removeTween",
        value: function removeTween(tween) {
            var len = arguments.length;
            if (len > 1) {
                for (var i = 0; i < len; ++i) {
                    this.removeTween(arguments[tween]);
                }
            } else {
                var _i = this._tweens.indexOf(tween);
                if (_i !== -1) {
                    this._tweens[_i].kill();
                    this._tweens.splice(_i, 1);
                }
            }
            return tween;
        }
    }, {
        key: "pauseAllTweens",
        value: function pauseAllTweens() {
            for (var i = 0; i < this._tweens.length; ++i) {
                this._tweens[i].pause();
            }
        }
    }, {
        key: "resumeAllTweens",
        value: function resumeAllTweens() {
            for (var i = 0; i < this._tweens.length; ++i) {
                this._tweens[i].resume();
            }
        }
    }, {
        key: "killAllTweens",
        value: function killAllTweens() {
            for (var i = 0; i < this._tweens.length; ++i) {
                this._tweens[i].kill();
            }
        }
    }]);

    return Scene;
}(PIXI.Container);

exports.default = Scene;

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Scene = require("./Scene");

var _Scene2 = _interopRequireDefault(_Scene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3
 */
var SceneManager = function () {
    /**
     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer
     */
    function SceneManager(renderer) {
        _classCallCheck(this, SceneManager);

        /**
         * @member {Object}
         * @member {signals.Signal} signals.next
         */
        this.signals = {
            next: new signals.Signal()
        };

        /**
         * @member {PIXI.Container}
         * @private
         */
        this._view = new PIXI.Container();

        /**
         * @member {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
         * @private
         */
        this._renderer = renderer;

        /**
         * @member {Object}
         * @private
         */
        this._next = null;

        /**
         * @type {Array.<Scene>}
         * @private
         */
        this._stack = [];
    }

    /**
     * Shows the next Scene. This will destroy all current scenes and remove them from the stack.
     * @param {Scene} scene - The scene to show.
     */


    _createClass(SceneManager, [{
        key: "show",
        value: function show(scene) {
            this._next = {};
            this._next.type = 0;
            this._next.scene = scene;
        }

        /**
         * @param {Scene} scene - The scene to add.
         * @param {boolean} [replace] - All other scenes are removed from the display list but will remain in the stack.
         */

    }, {
        key: "add",
        value: function add(scene, replace) {
            this._next = {};
            this._next.type = 1;
            this._next.scene = scene;
            this._next.replace = replace;
        }

        /**
         * @param {Scene} scene - The scene to add.
         * @param {number} [count=1] - The number of scenes to swap with the new scene.
         */

    }, {
        key: "swap",
        value: function swap(scene, count) {
            this._next = {};
            this._next.type = 2;
            this._next.scene = scene;
            this._next.removeCount = Math.max(1, count) || 1;
        }

        /**
         * Remove a Scene from the top of the stack.
         * @param {number} [count=1] - The number of scenes to remove from the stack.
         */

    }, {
        key: "remove",
        value: function remove(count) {
            this._next = {};
            this._next.type = 2;
            this._next.removeCount = Math.max(1, count) || 1;
        }

        /**
         * Remove all Scenes from the stack.
         */

    }, {
        key: "removeAll",
        value: function removeAll() {
            this._next = {};
            this._next.type = 3;
            this._next.removeCount = Number.MAX_SAFE_INTEGER;
        }

        /**
         * Destroys all Scenes in the stack.
         */

    }, {
        key: "clear",
        value: function clear() {
            if (this._transitionInProgress) return;

            for (var i = 0; i < this._stack.length; ++i) {
                var scene = this._stack[i];
                if (scene.parent) {
                    scene.hide();
                    scene.parent.removeChild(scene);
                }
                scene.destroy({ children: true });
            }
            this._stack.length = 0;
        }

        /**
         * Updates the Scene at the top of the stack.
         */

    }, {
        key: "update",
        value: function update() {
            this._next && this._nextScene();

            if (this._stack.length) {
                this.top.update();
                for (var i = 0; i < this._stack.length - 1; ++i) {
                    var scene = this._stack[i];
                    scene.alwaysUpdate && scene.update();
                }
            }
        }

        /**
         * Attempts to resize any children added to the SceneManagers view.
         */

    }, {
        key: "resize",
        value: function resize() {
            for (var i = 0; i < this._view.children.length; ++i) {
                var child = this._view.children[i];
                child.resize && child.resize();
            }
        }

        /**
         * @private
         */

    }, {
        key: "_nextScene",
        value: function _nextScene() {
            var next = this._next;
            this._next = null;

            var scene = next.scene;

            if (this.top) {
                this.top.hide();

                switch (next.type) {
                    // show
                    case 0:
                        {
                            while (this.top) {
                                this._removeTop();
                            }break;
                        }
                    // add
                    case 1:
                        {
                            if (next.replace) {
                                for (var i = this._stack.length - 1; i >= 0; --i) {
                                    var other = this._stack[i];
                                    other.parent && other.parent.removeChild(other);
                                }
                            }
                            break;
                        }
                    // remove
                    case 2:
                        {
                            var count = Math.min(this._stack.length, next.removeCount);
                            for (var _i = 0; _i < count; ++_i) {
                                this._removeTop();
                            }
                            break;
                        }
                }
            }

            if (scene) {
                scene.init();
                this._stack.push(scene);
            } else {
                scene = this.top;
            }

            if (scene) {
                scene.resize();
                !scene.parent && this._view.addChild(scene);

                scene.show();
                if (next.type !== 3 && scene.autoAppear) {
                    scene.appear();
                }
            }

            console.log("stack:", this._stack);
            this.signals.next.dispatch(this, scene);
        }

        /**
         * @private
         */

    }, {
        key: "_removeTop",
        value: function _removeTop() {
            this.top.parent && this.top.parent.removeChild(this.top);
            this.top.destroy({ children: true });
            this.top.unload();
            this._stack.pop();
        }

        /**
         * @returns {PIXI.Container}
         */

    }, {
        key: "view",
        get: function get() {
            return this._view;
        }

        /**
         * @returns {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
         */

    }, {
        key: "renderer",
        get: function get() {
            return this._renderer;
        }

        /**
         * The top most Scene in the stack.
         * @returns {Scene}
         */

    }, {
        key: "top",
        get: function get() {
            return this._stack.length ? this._stack[this._stack.length - 1] : null;
        }
    }]);

    return SceneManager;
}();

exports.default = SceneManager;

},{"./Scene":16}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3
 */
var View = function () {
    /**
     * @param {Object} [options]
     * @param {boolean} [options.width=0]
     * @param {number} [options.height=0]
     * @param {string} [options.holderId]
     * @param {boolean} [options.portrait=false]
     * @param {string} [options.rotateImageUrl]
     * @param {number} [options.rotateImageColor=0xFFFFFF]
     * @param {boolean} [options.aspectRatioFillHeight=true]
     */
    function View(options) {
        _classCallCheck(this, View);

        /**
         * @member {Object}
         */
        this.signals = {};

        /**
         * @member {signals.Signal}
         */
        this.signals.ready = new signals.Signal();

        /**
         * @member {signals.Signal}
         */
        this.signals.resize = new signals.Signal();

        /**
         * @type {Object}
         * @private
         */
        this._options = Object.assign({}, {
            width: 0,
            height: 0,
            holderId: "game",
            portrait: false,
            rotateImageColor: 0xFFFFFF,
            aspectRatioFillHeight: true
        }, options);

        /**
         * @member {Element}
         * @private
         */
        this._holder = null;

        /**
         * @member {Element}
         * @private
         */
        this._canvas = null;

        /**
         * @member {Element}
         * @private
         */
        this._iosfix = null;

        /**
         * @member {Element}
         * @private
         */
        this._rotateImage = null;

        /**
         * @type {string}
         * @private
         */
        this._targetOrientation = this._options.portrait ? "portrait" : "landscape";

        if (document.readyState !== "complete") {
            window.self.onload = this._onLoad.bind(this);
        } else {
            this._onLoad();
        }
    }

    /**
     */


    _createClass(View, [{
        key: "resize",
        value: function resize() {
            var width = _ismobilejs2.default.any ? document.documentElement.clientWidth : window.innerWidth;
            var height = _ismobilejs2.default.any ? document.documentElement.clientHeight : window.innerHeight;

            if (window.self === window.top) {
                this._holder.style.width = width + "px";
                this._holder.style.height = height + "px";
            } else {
                this._holder.style.width = "100%";
                this._holder.style.height = "100%";
            }

            if (_ismobilejs2.default.apple.device) {
                this._iosfix.style.height = parseInt(this._holder.style.height) + 1 + "px";
            }

            // this scroll is used in IOS 8.0+ to move the game down when the user clicks to show the scrollbar.
            window.scrollTo(0, 0);

            if (this._options.aspectRatioFillHeight) {
                var ratioW = width / this._options.width;
                var ratioH = this._options.height / height;

                this._updateDimensions(Math.floor(this._options.width * ratioW * ratioH), this._options.height);
            } else {
                var _ratioW = this._options.width / width;
                var _ratioH = height / this._options.height;

                this._updateDimensions(this._options.width, Math.floor(this._options.height * _ratioH * _ratioW));
            }

            this.toggleRotate(!this.isCorrectOrientation);
            this.signals.resize.dispatch(this.isCorrectOrientation);
        }

        /**
         * @param {boolean} value
         */

    }, {
        key: "toggleRotate",
        value: function toggleRotate(value) {
            this._canvas.style.display = value ? "none" : "block";
            this._rotateImage.style.display = value ? "block" : "none";
        }

        /**
         * @private
         */

    }, {
        key: "_createHolder",
        value: function _createHolder() {
            if (navigator["isCocoonJS"]) return;

            this._holder = document.getElementById(this._options.holderId);
            if (!this._holder) {
                this._holder = document.createElement("div");
                this._holder.id = this._options.holderId;
                document.body.appendChild(this._holder);
            }

            this._holder.style.position = "absolute";
            this._holder.style.left = 0;
            this._holder.style.top = 0;
            this._holder.style.width = window.self.innerWidth + "px";
            this._holder.style.height = window.self.innerHeight + "px";
            View.holder = this._holder;

            // forces the browser bars to be hidden in iOS9
            if (_ismobilejs2.default.apple.device) {
                this._iosfix = document.createElement("div");
                this._iosfix.id = "iosfix";
                this._iosfix.style.position = "absolute";
                this._iosfix.style.left = 0;
                this._iosfix.style.right = 0;
                this._iosfix.style.top = 0;
                this._iosfix.style.bottom = 0;
                this._iosfix.style.width = "100%";
                this._iosfix.style.height = this._holder.height + 1;
                this._iosfix.style.visibility = "hidden";
                document.body.appendChild(this._iosfix);
                View.iosfix = this._iosfix;
            }
        }

        /**
         * @private
         */

    }, {
        key: "_createCanvas",
        value: function _createCanvas() {
            if (navigator["isCocoonJS"]) {
                this._canvas = document.createElement("screencanvas");
                this._canvas.id = "canvas";
                this._canvas.width = this._options.width;
                this._canvas.height = this._options.height;
                this._canvas.style.cssText = "idtkscale:ScaleAspectFill;";
                document.body.appendChild(this._canvas);
            } else {
                this._canvas = document.createElement("canvas");
                this._canvas.id = "canvas";
                this._canvas.tabIndex = 1;
                this._canvas.style.position = "absolute";
                this._canvas.style.left = 0;
                this._canvas.style.right = 0;
                this._canvas.style.top = 0;
                this._canvas.style.bottom = 0;
                this._canvas.style.width = "100%";
                this._canvas.style.height = "100%";
                this._canvas.style.overflow = "visible";
                this._canvas.style.display = "block";
                this._holder.appendChild(this._canvas);
            }
            View.canvas = this._canvas;
        }

        /**
         * @private
         */

    }, {
        key: "_createRotateImage",
        value: function _createRotateImage() {
            if (navigator["isCocoonJS"]) return;

            this._rotateImage = document.createElement("div");
            this._rotateImage.id = "rotateImage";
            this._rotateImage.style.position = "absolute";
            this._rotateImage.style.left = 0;
            this._rotateImage.style.top = 0;

            this._rotateImage.style.width = "100%";
            this._rotateImage.style.height = "100%";
            this._rotateImage.style.marginLeft = "auto";
            this._rotateImage.style.marginRight = 0 + "auto";
            this._rotateImage.style.overflow = "visible";
            this._rotateImage.style.display = "none";
            this._rotateImage.style.zIndex = 1000;

            this._rotateImage.style.backgroundImage = this._options.rotateImageUrl ? "url(" + this._options.rotateImageUrl + ")" : "";
            this._rotateImage.style.backgroundColor = this._options.rotateImageColor || 0xFFFFFF;
            this._rotateImage.style.backgroundPosition = "50% 50%";
            this._rotateImage.style.backgroundRepeat = "no-repeat";
            this._rotateImage.style.backgroundSize = "100% auto";

            this._holder.appendChild(this._rotateImage);

            // prevent dragging the ui
            this._rotateImage.addEventListener("touchmove", function (event) {
                event.preventDefault();
                return false;
            });

            // prevent dragging the ui
            this._rotateImage.addEventListener("touchstart", function (event) {
                event.preventDefault();
                return false;
            });

            // prevent dragging the ui
            this._rotateImage.addEventListener("touchend", function (event) {
                event.preventDefault();
                return false;
            });
        }

        /**
         * @param {number} width
         * @param {number} height
         * @private
         */

    }, {
        key: "_updateDimensions",
        value: function _updateDimensions(width, height) {
            View.width = this._width = Math.round(width);
            View.height = this._height = Math.round(height);
            View.center.x = Math.round(width * 0.5);
            View.center.y = Math.round(height * 0.5);
        }

        /**
         * @private
         */

    }, {
        key: "_disableInteractions",
        value: function _disableInteractions() {
            // prevent dragging the ui
            View.canvas.addEventListener("touchmove", function (event) {
                event.preventDefault();
                return false;
            });

            // prevent dragging the ui
            View.canvas.addEventListener("touchstart", function (event) {
                event.preventDefault();
                return false;
            });

            // prevent dragging the ui
            View.canvas.addEventListener("touchend", function (event) {
                event.preventDefault();
                return false;
            });

            if (_ismobilejs2.default.android.device) {
                View.canvas.addEventListener("mousedown", function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }, false);

                View.canvas.addEventListener("mouseup", function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }, false);

                View.canvas.addEventListener("click", function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }, false);
            }
        }

        /**
         * @private
         */

    }, {
        key: "_onLoad",
        value: function _onLoad() {
            var that = this;
            setTimeout(function () {
                init.call(that);
            }, 0);

            function init() {
                this._createHolder();
                this._createCanvas();
                this._createRotateImage();
                this._disableInteractions();

                if (navigator["isCocoonJS"]) {
                    this.updateDimensions(this._options.width * (window.innerWidth / this._options.width) / (window.innerHeight / this._options.height), this._options.height);
                    this.signals.ready.dispatch(this._canvas);
                } else {
                    if (_ismobilejs2.default.android.device) {
                        window.self.addEventListener("orientationchange", this._onOrientationChange.bind(this), false);
                    } else {
                        window.self.addEventListener("resize", this._onResize.bind(this), false);
                    }
                    this.signals.ready.dispatch(this._canvas);

                    this.resize();
                }
            }
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onResize",
        value: function _onResize(event) {
            this.resize();
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onOrientationChange",
        value: function _onOrientationChange(event) {
            window.self.addEventListener("resize", listener, false);

            var that = this;
            function listener() {
                window.self.removeEventListener("resize", listener, false);
                that.resize();
            }
        }

        /**
         * @returns {Element}
         */

    }, {
        key: "holder",
        get: function get() {
            return this._holder;
        }

        /**
         * @returns {Object}
         */

    }, {
        key: "options",
        get: function get() {
            return this._options;
        }

        /**
         * @returns {string}
         */

    }, {
        key: "orientation",
        get: function get() {
            return this._width >= this._height ? "landscape" : "portrait";
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "isCorrectOrientation",
        get: function get() {
            return _ismobilejs2.default.any ? this.orientation === this._targetOrientation : true;
        }
    }]);

    return View;
}();

/**
 * @type {Element}
 */


exports.default = View;
View.holder = null;

/**
 * @type {Element}
 */
View.canvas = null;

/**
 * @type {number}
 */
View.width = 0;

/**
 * @type {number}
 */
View.height = 0;

/**
 * @type {PIXI.Point}
 */
View.center = new PIXI.Point();

},{"ismobilejs":1}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Two Pi.
 *
 * @static
 * @constant
 * @memberOf P3
 * @type {number}
 */
var PI_2 = exports.PI_2 = Math.PI * 2;

/**
 * Conversion factor for converting radians to degrees.
 *
 * @static
 * @constant
 * @memberOf P3
 * @type {number}
 */
var RAD_TO_DEG = exports.RAD_TO_DEG = 180 / Math.PI;

/**
 * Conversion factor for converting degrees to radians.
 *
 * @static
 * @constant
 * @memberOf P3
 * @type {number}
 */
var DEG_TO_RAD = exports.DEG_TO_RAD = Math.PI / 180;

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = require("./const");

Object.keys(_const).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _const[key];
    }
  });
});

var _AssetManager = require("./AssetManager");

Object.defineProperty(exports, "AssetManager", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AssetManager).default;
  }
});

var _Button = require("./Button");

Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

var _ButtonManager = require("./ButtonManager");

Object.defineProperty(exports, "ButtonManager", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonManager).default;
  }
});

var _ButtonStates = require("./ButtonStates");

Object.defineProperty(exports, "ButtonStates", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonStates).default;
  }
});

var _Input = require("./Input");

Object.defineProperty(exports, "Input", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

var _MovieClip = require("./MovieClip");

Object.defineProperty(exports, "MovieClip", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MovieClip).default;
  }
});

var _MovieClipSequence = require("./MovieClipSequence");

Object.defineProperty(exports, "MovieClipSequence", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MovieClipSequence).default;
  }
});

var _MuteButton = require("./MuteButton");

Object.defineProperty(exports, "MuteButton", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MuteButton).default;
  }
});

var _Scene = require("./Scene");

Object.defineProperty(exports, "Scene", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Scene).default;
  }
});

var _SceneManager = require("./SceneManager");

Object.defineProperty(exports, "SceneManager", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SceneManager).default;
  }
});

var _View = require("./View");

Object.defineProperty(exports, "View", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_View).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./AssetManager":8,"./Button":9,"./ButtonManager":10,"./ButtonStates":11,"./Input":12,"./MovieClip":13,"./MovieClipSequence":14,"./MuteButton":15,"./Scene":16,"./SceneManager":17,"./View":18,"./const":19}],21:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utils = exports.math = undefined;

var _audio = require("./audio");

Object.keys(_audio).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _audio[key];
        }
    });
});

var _camera = require("./camera");

Object.keys(_camera).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _camera[key];
        }
    });
});

var _core = require("./core");

Object.keys(_core).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _core[key];
        }
    });
});

var _math = require("./math");

Object.keys(_math).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _math[key];
        }
    });
});

var _transition = require("./transition");

Object.keys(_transition).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _transition[key];
        }
    });
});

var math = _interopRequireWildcard(_math);

var _utils = require("./utils");

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.math = math;
exports.utils = utils;


global.P3 = exports;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./audio":4,"./camera":7,"./core":20,"./math":24,"./transition":27,"./utils":29}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.math
 */
var Color = function () {
    /**
     * @param {number|string} [hex=0x0]
     * @param {number} [alpha=0]
     */
    function Color() {
        var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0x0;
        var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        _classCallCheck(this, Color);

        /**
         * @member {number}
         */
        this._r = 0;

        /**
         * @member {number}
         */
        this._g = 0;

        /**
         * @member {number}
         */
        this._b = 0;

        /**
         * @member {number}
         */
        this._a = alpha;

        /**
         * @member {number}
         */
        this._h = 0;

        /**
         * @member {number}
         */
        this._s = 0;

        /**
         * @member {number}
         */
        this._v = 0;

        this.setHex(hex);
    }

    /**
     * @param {number} value
     * @returns {string}
     */


    _createClass(Color, [{
        key: "setHex",


        /**
         * Set the color from a hex formatted string.
         * http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
         *
         * @param {number|string} value
         * @returns {Color}
         */
        value: function setHex(value) {
            if (typeof value === "number") {
                value = Color.hexNumberToString(value);
            }

            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            var hex = value.replace(shorthandRegex, function (m, r, g, b) {
                return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            if (result) {
                this._r = parseInt(result[1], 16) / 255;
                this._g = parseInt(result[2], 16) / 255;
                this._b = parseInt(result[3], 16) / 255;

                this._updateHSV();
            }
            return this;
        }

        /**
         * Set the color from another color.
         *
         * @param {Color} color
         * @returns {Color}
         */

    }, {
        key: "setColor",
        value: function setColor(color) {
            this._r = color.r;
            this._g = color.g;
            this._b = color.b;
            this._a = color.a;
            this._h = color.h;
            this._s = color.s;
            this._v = color.v;
            return this;
        }

        /**
         * Set the color from RGB values.
         *
         * @param {number} r - The red value to set.
         * @param {number} g - The green value to set.
         * @param {number} b - The blue value to set.
         * @returns {Color}
         */

    }, {
        key: "setRGB",
        value: function setRGB(r, g, b) {
            this._r = r;
            this._g = g;
            this._b = b;

            this._updateHSV();
            return this;
        }

        /**
         * Set the color from the RGBA values.
         *
         * @param {number} r - The red value to set.
         * @param {number} g - The green value to set.
         * @param {number} b - The blue value to set.
         * @param {number} a - The alpha value to set.
         * @returns {Color}
         */

    }, {
        key: "setRGBA",
        value: function setRGBA(r, g, b, a) {
            this._a = a;

            this.setRGB(r, g, b);
            return this;
        }

        /**
         * Set the color from the HSV values.
         *
         * @param {number} h - The hue value to set.
         * @param {number} s - The saturation value to set.
         * @param {number} v - The brightness value to set.
         * @returns {Color}
         */

    }, {
        key: "setHSV",
        value: function setHSV(h, s, v) {
            this._h = h;
            this._s = s;
            this._v = v;

            this._updateRGB();
            return this;
        }

        /**
         * Desaturate the color.
         *
         * @param {number} [r] - Desaturation r ratio.
         * @param {number} [g] - Desaturation g ratio.
         * @param {number} [b] - Desaturation b ratio.
         * @returns {Color}
         */

    }, {
        key: "desaturate",
        value: function desaturate() {
            var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.59;
            var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.30;
            var b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.11;

            this._r = this._g * r + this._r * g + this._b * b;
            this._g = this._r;
            this._b = this._r;

            this._updateHSV();
            return this;
        }

        /**
         * Invert the color.
         *
         * @returns {Color}
         */

    }, {
        key: "invert",
        value: function invert() {
            this._r = 1 - this._r;
            this._g = 1 - this._g;
            this._b = 1 - this._b;

            this._updateHSV();
            return this;
        }

        /**
         * Blend the current color with the given one.
         *
         * @param {Color} to
         * @param {number} [t=0.5] A number between 0 and 1.
         */

    }, {
        key: "lerp",
        value: function lerp(to) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;

            t = Math.min(1, Math.max(0, t));

            this._r = this._r * (1 - t) + to.r * t;
            this._g = this._g * (1 - t) + to.g * t;
            this._b = this._b * (1 - t) + to.b * t;

            this._updateHSV();
            return this;
        }

        /**
         * Randomize the color's values
         *
         * @returns {Color}
         */

    }, {
        key: "random",
        value: function random() {
            this._r = Math.random();
            this._g = Math.random();
            this._b = Math.random();

            this._updateHSV();
            return this;
        }

        /**
         * Normalize the color's values.
         *
         * @private
         */

    }, {
        key: "_normalize",
        value: function _normalize() {
            this._r = this._r < 0 ? 0 : this._r > 1 ? 1 : this._r;
            this._g = this._g < 0 ? 0 : this._g > 1 ? 1 : this._g;
            this._b = this._b < 0 ? 0 : this._b > 1 ? 1 : this._b;
            this._a = this._a < 0 ? 0 : this._a > 1 ? 1 : this._a;
            this._h = Number((this._h - Math.floor(this._h)).toPrecision(8));
            this._s = this._s < 0 ? 0 : this._s > 1 ? 1 : this._s;
            this._v = this._v < 0 ? 0 : this._v > 1 ? 1 : this._v;
        }

        /**
         * Update the color's RGB values from the HSV ones.
         * http://stackoverflow.com/questions/17242144/javascript-convert-hsb-hsv-color-to-rgb-accurately
         *
         * @private
         */

    }, {
        key: "_updateRGB",
        value: function _updateRGB() {
            this._normalize();

            var i = Math.floor(this._h * 6);
            var f = this._h * 6 - i;
            var p = this._v * (1 - this._s);
            var q = this._v * (1 - f * this._s);
            var t = this._v * (1 - (1 - f) * this._s);

            switch (i % 6) {
                case 0:
                    this._r = this._v;
                    this._g = t;
                    this._b = p;
                    break;

                case 1:
                    this._r = q;
                    this._g = this._v;
                    this._b = p;
                    break;

                case 2:
                    this._r = p;
                    this._g = this._v;
                    this._b = t;
                    break;

                case 3:
                    this._r = p;
                    this._g = q;
                    this._b = this._v;
                    break;

                case 4:
                    this._r = t;
                    this._g = p;
                    this._b = this._v;
                    break;

                case 5:
                    this._r = this._v;
                    this._g = p;
                    this._b = q;
                    break;
            }
        }

        /**
         * Update the color's HSV values from the RGB ones.
         * http://www.deadbeef.com/converting_rgb_to_hsv_in_c/
         *
         * @private
         */

    }, {
        key: "_updateHSV",
        value: function _updateHSV() {
            this._normalize();

            var maxC = Math.max(this._r, this._g, this._b);
            var minC = Math.min(this._r, this._g, this._b);
            var delta = maxC - minC;

            var h = 0;
            var s = 0;
            var v = maxC;

            if (delta == 0) {
                h = 0;
                s = 0;
            } else {
                s = delta / maxC;
                var dR = 60 * (maxC - this._r) / delta + 180;
                var dG = 60 * (maxC - this._g) / delta + 180;
                var dB = 60 * (maxC - this._b) / delta + 180;
                if (this._r == maxC) h = dB - dG;else if (this._g == maxC) h = 120 + dR - dB;else h = 240 + dG - dR;
            }

            if (h < 0) h += 360;
            if (h >= 360) h -= 360;

            this._h = h / 360;
            this._s = s;
            this._v = v;
        }

        /**
         * Return the hex value of the color.
         * http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
         *
         * @returns {string}
         */

    }, {
        key: "toHex",
        value: function toHex() {
            return "#" + ((1 << 24) + (Math.round(this._r * 255) << 16) + (Math.round(this._g * 255) << 8) + Math.round(this._b * 255)).toString(16).slice(1);
        }

        /**
         * @returns {number}
         */

    }, {
        key: "toNumber",
        value: function toNumber() {
            return (Math.round(this._r * 255) << 16) + (Math.round(this._g * 255) << 8) + Math.round(this._b * 255);
        }

        /**
         * Return the CSS RGBA value.
         *
         * @returns {string}
         */

    }, {
        key: "toCSS",
        value: function toCSS() {
            return "rgba(" + Math.round(this._r * 255) + "," + Math.round(this._g * 255) + "," + Math.round(this._b * 255) + "," + this._a + ")";
        }

        /**
         * Get the color's red value.
         *
         * @returns {number}
         */

    }, {
        key: "r",
        get: function get() {
            return this._r;
        }

        /**
         * Set the color's red value.
         *
         * @param {number} value - The red value to set.
         */
        ,
        set: function set(value) {
            this._r = value;
            this._updateHSV();
        }

        /**
         * Get the color's green value.
         *
         * @returns {number}
         */

    }, {
        key: "g",
        get: function get() {
            return this._g;
        }

        /**
         * Set the color's green value.
         *
         * @param {number} value - The green value to set.
         */
        ,
        set: function set(value) {
            this._g = value;
            this._updateHSV();
        }

        /**
         * Get the color's blue value.
         *
         * @returns {number}
         */

    }, {
        key: "b",
        get: function get() {
            return this._b;
        }

        /**
         * Set the color's blue value.
         *
         * @param {number} value - The blue value to set.
         */
        ,
        set: function set(value) {
            this._b = value;
            this._updateHSV();
        }

        /**
         * Get the color's alpha value.
         *
         * @returns {number}
         */

    }, {
        key: "a",
        get: function get() {
            return this._a;
        }

        /**
         * Set the color's alpha value.
         *
         * @param {number} value - The alpha value to set.
         */
        ,
        set: function set(value) {
            this._a = value;
        }

        /**
         * Get the color's hue value.
         *
         * @returns {number}
         */

    }, {
        key: "h",
        get: function get() {
            return this._h;
        }

        /**
         * Set the color's hue value.
         *
         * @param {number} value - The hue value to set.
         */
        ,
        set: function set(value) {
            this._h = value;
            this._updateRGB();
        }

        /**
         * Get the color's saturation value.
         *
         * @returns {number}
         */

    }, {
        key: "s",
        get: function get() {
            return this._s;
        }

        /**
         * Set the color's saturation value.
         *
         * @param {number} value - The saturation to set.
         */
        ,
        set: function set(value) {
            this._s = value;
            this._updateRGB();
        }

        /**
         * Get the color's brightness value.
         *
         * @returns {number}
         */

    }, {
        key: "v",
        get: function get() {
            return this._v;
        }

        /**
         * Set the color's brightness value.
         *
         * @param {number} value - The brightness to set.
         */
        ,
        set: function set(value) {
            this._v = value;
            this._updateRGB();
        }

        /**
         * The luminosity of the color.
         * http://stackoverflow.com/questions/596216/formula-to-determine-brightness-of-rgb-color
         *
         * @returns {number}
         */

    }, {
        key: "luminosity",
        get: function get() {
            return 0.299 * this._r + 0.587 * this._g + 0.114 * this._b;
        }
    }], [{
        key: "hexNumberToString",
        value: function hexNumberToString(value) {
            var pad = "#000000";
            var hex = parseInt(value).toString(16);
            return pad.substring(0, pad.length - hex.length) + hex;
        }
    }]);

    return Color;
}();

exports.default = Color;

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.math
 */
var Vector2 = function () {
    /**
     * @param {number} [x=0] - The x axis of the vector.
     * @param {number} [y=0] - The y axis of the vector.
     */
    function Vector2() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        _classCallCheck(this, Vector2);

        /**
         * @member {number}
         */
        this.x = x;

        /**
         * @member {number}
         */
        this.y = y;
    }

    /**
     * Returns a new vector equal to the sum of the vector plus the given vector.
     *
     * @param {Vector2} v - The vector to add.
     * @returns {Vector2}
     */


    _createClass(Vector2, [{
        key: "add",
        value: function add(v) {
            return new Vector2(this.x + v.x, this.y + v.y);
        }

        /**
         * Returns a new vector equal to the sum of the vector minus the given vector.
         *
         * @param {Vector2} v - The vector to subtract.
         * @returns {Vector2}
         */

    }, {
        key: "subtract",
        value: function subtract(v) {
            return new Vector2(this.x - v.x, this.y - v.y);
        }

        /**
         * Returns a new vector equal to the sum of the vector scaled by the given value.
         *
         * @param {number} s - The amount to scale the vector by.
         * @returns {Vector2}
         */

    }, {
        key: "scale",
        value: function scale(s) {
            return new Vector2(this.x * s, this.y * s);
        }

        /**
         * Increments this vector by the given vector.
         *
         * @param {Vector2} v - The vector to add.
         * @returns {Vector2}
         */

    }, {
        key: "incrementBy",
        value: function incrementBy(v) {
            this.x += v.x;
            this.y += v.y;
            return this;
        }

        /**
         * Decrements this vector by the given vector.
         *
         * @param {Vector2} v - The vector to subtract.
         * @returns {Vector2}
         */

    }, {
        key: "decrementBy",
        value: function decrementBy(v) {
            this.x -= v.x;
            this.y -= v.y;
            return this;
        }

        /**
         * Scale this vector by the given value.
         * @param {number} s - The amount to scale the vector by.
         * @returns {Vector2}
         */

    }, {
        key: "scaleBy",
        value: function scaleBy(s) {
            this.x *= s;
            this.y *= s;
            return this;
        }

        /**
         * Normalize the vector to a length of 1.
         * @returns {Vector2}
         */

    }, {
        key: "normalize",
        value: function normalize() {
            var l = this.length;
            if (l > 0) {
                this.x /= l;
                this.y /= l;
            }
            return this;
        }

        /**
         * Crop the vector to the given length.
         *
         * @param {number} length - The length the vector must exceed.
         * @returns {Vector2}
         */

    }, {
        key: "truncate",
        value: function truncate(length) {
            var l = this.length;
            if (l > length) {
                this.x /= l * length;
                this.y /= l * length;
            }
            return this;
        }

        /**
         * Returns the left hand normal of this vector.
         *
         * @returns {Vector2}
         */

    }, {
        key: "normal",
        value: function normal() {
            return new Vector2(this.y, -this.x);
        }

        /**
         * Returns the dot product for this and the given vector.
         *
         * @param {Vector2} v - The other vector in the equation.
         * @returns {number}
         */

    }, {
        key: "dot",
        value: function dot(v) {
            return this.x * v.x + this.y * v.y;
        }

        /**
         * Returns the dot product for the left hand normal of this vector and the given vector.
         *
         * @param {Vector2} v - The other vector in the equation.
         * @returns {number}
         */

    }, {
        key: "perp",
        value: function perp(v) {
            return -this.y * v.x + this.x * v.y;
        }

        /**
         * Returns a new vector equal to the projection of this vector along the given axis.
         *
         * @param {Vector2} v - The axis we project this vector along.
         * @returns {Vector2}
         */

    }, {
        key: "project",
        value: function project(v) {
            v = v.clone().normalize();
            return v.scale(this.dot(v));
        }

        /**
         * Returns the angle between this vector and the given vector.
         *
         * @param {Vector2} v - The other vector in the equation.
         * @returns {number}
         */

    }, {
        key: "angleBetween",
        value: function angleBetween(v) {
            return Math.atan2(v.y - this.y, v.x - this.x);
        }

        /**
         * Rotate the vector.
         *
         * @param {number} angle - The angle in radians to rotate the vector by.
         * @returns {Vector2}
         */

    }, {
        key: "rotate",
        value: function rotate(angle) {
            var cos = Math.cos(angle);
            var sin = Math.sin(angle);

            var x = cos * this.x - sin * this.y;
            var y = cos * this.y + sin * this.x;

            this.x = x;
            this.y = y;

            return this;
        }

        /**
         * Rotate the vector around a point.
         *
         * @param {number} x - The x axis to rotate around.
         * @param {number} y - The y axis to rotate around.
         * @param {number} angle - The angle in radians to rotate the Vector2 by.
         * @returns {Vector2}
         */

    }, {
        key: "rotateAround",
        value: function rotateAround(x, y, angle) {
            this.x -= x;
            this.y -= y;

            this.rotate(angle);

            this.x += x;
            this.y += y;

            return this;
        }

        /**
         * Creates a clone of the vector.
         *
         * @returns {Vector2}
         */

    }, {
        key: "clone",
        value: function clone() {
            return new Vector2(this.x, this.y);
        }

        /**
         * Copies x and y from the given vector.
         *
         * @param {Vector2} v - The vector to copy.
         */

    }, {
        key: "copy",
        value: function copy(v) {
            this.set(v.x, v.y);
        }

        /**
         * Returns true if the given vector is equal to the given vector.
         *
         * @param {Vector2} v - The vector to compare with.
         * @returns {boolean}
         */

    }, {
        key: "equals",
        value: function equals(v) {
            return v.x === this.x && v.x === this.y;
        }

        /**
         * Sets the vector to a new x and y axis.
         * If the y is omitted, both x and y will be set to x.
         *
         * @param {number} [x=0]
         * @param {number} [y=0]
         */

    }, {
        key: "set",
        value: function set(x, y) {
            this.x = x || 0;
            this.y = y || (y !== 0 ? this.x : 0);
        }

        /**
         * Returns a unit vector.
         *
         * @returns {Vector2}
         */

    }, {
        key: "unit",
        value: function unit() {
            var v = this.clone();
            v.normalize();
            return v;
        }

        /**
         * Return the angle (in radians) of the vector.
         *
         * @returns {number}
         */

    }, {
        key: "angle",
        get: function get() {
            return Math.atan2(this.y, this.x);
        }

        /**
         * Returns the magnitude of the vector.
         *
         * @returns {number}
         */

    }, {
        key: "length",
        get: function get() {
            return Math.sqrt(this.lengthSq);
        }

        /**
         * Returns the magnitude squared of the vector.
         * This is significantly faster than getting the length.
         *
         * @returns {number}
         */

    }, {
        key: "lengthSq",
        get: function get() {
            return this.x * this.x + this.y * this.y;
        }
    }]);

    return Vector2;
}();

exports.default = Vector2;

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Color = require("./Color");

Object.defineProperty(exports, "Color", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Color).default;
    }
});

var _Vector = require("./Vector2");

Object.defineProperty(exports, "Vector2", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Vector).default;
    }
});
exports.random = random;
exports.randomInt = randomInt;
exports.randomBool = randomBool;
exports.randomSign = randomSign;
exports.roundNum = roundNum;
exports.sign = sign;
exports.clamp = clamp;
exports.lerp = lerp;
exports.fmod = fmod;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a random number within a range.
 *
 * @param {number} min - The minimum value (inclusive).
 * @param {number} max - The maximum value (exclusive).
 * @returns {number}
 */
function random(min, max) {
    return Math.random() * (max - min) + min;
}

/**
 * Returns a random integer within a range.
 *
 * @param {number} min - The minimum value (inclusive).
 * @param {number} max - The minimum value (inclusive).
 * @returns {number}
 */
function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Returns a random boolean.
 *
 * @returns {boolean}
 */
function randomBool() {
    return Math.random() < 0.5;
}

/**
 * Return -1 or 1.
 *
 * @returns {number}
 */
function randomSign() {
    return randomInt(0, 1) * 2 - 1;
}

/**
 * Rounds a value to a number of decimal places.
 *
 * @param {number} n - The value to round.
 * @param {number} [decimalPlaces=0] - The number of decimal places to round this number to.
 * @returns {number}
 */
function roundNum(n) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var decimals = Math.pow(10, decimalPlaces);
    return Math.round(Math.floor(n * decimals) / decimals);
}

/**
 * Return the sign of the given number.
 *
 * @param {number} n
 */
function sign(n) {
    if (Math.abs(n) > 0) {
        return n / Math.abs(n);
    }
    return 0;
}

/**
 * Clamps a value to a range.
 *
 * @param {number} n
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
function clamp(n, min, max) {
    if (n < min) {
        n = min;
    } else if (n > max) {
        n = max;
    }
    return n;
}

/**
 * Linearly interpolate between two values.
 *
 * @param {number} a
 * @param {number} b
 * @param {number} t
 */
function lerp(a, b, t) {
    return a + (b - a) * t;
}

/**
 * https://gist.github.com/wteuber/6241786
 *
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */
function fmod(a, b) {
    return Number((a - Math.floor(a / b) * b).toPrecision(8));
}

},{"./Color":22,"./Vector2":23}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Transition2 = require("./Transition");

var _Transition3 = _interopRequireDefault(_Transition2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3.transition
 */
var FadeTransition = function (_Transition) {
    _inherits(FadeTransition, _Transition);

    /**
     * @param {number} [color]
     * @param {number} [duration]
     */
    function FadeTransition(color, duration) {
        _classCallCheck(this, FadeTransition);

        /**
         * @member {number}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (FadeTransition.__proto__ || Object.getPrototypeOf(FadeTransition)).call(this));

        _this._color = color || 0x0;

        /**
         * @member {number}
         * @private
         */
        _this._duration = duration || 0.8;

        /**
         * @member {PIXI.Graphics}
         * @private
         */
        _this._quad = null;
        return _this;
    }

    _createClass(FadeTransition, [{
        key: "init",
        value: function init() {
            _get(FadeTransition.prototype.__proto__ || Object.getPrototypeOf(FadeTransition.prototype), "init", this).call(this);

            this._quad = new PIXI.Graphics();
            this._quad.visible = false;
            this.addChild(this._quad);

            this.resize();
        }

        /**
         * @param {number} [delay=0]
         */

    }, {
        key: "in",
        value: function _in() {
            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            this._quad.alpha = 0;
            this._quad.visible = true;
            TweenMax.to(this._quad, this._duration * 0.5, {
                delay: delay,
                alpha: 1,
                ease: Power2.easeInOut,
                onComplete: function onComplete() {
                    this.signals.in.dispatch(this);
                },
                onCompleteScope: this
            });
        }

        /**
         * @param {number} [delay=0.5]
         */

    }, {
        key: "out",
        value: function out() {
            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;

            TweenMax.to(this._quad, this._duration * 0.5, {
                delay: delay,
                alpha: 0,
                ease: Power2.easeInOut,
                onComplete: function onComplete() {
                    this._quad.visible = false;
                    this.signals.out.dispatch(this);
                },
                onCompleteScope: this
            });
        }
    }, {
        key: "resize",
        value: function resize() {
            this._quad.clear();
            this._quad.beginFill(this._color);
            this._quad.drawRect(0, 0, P3.View.width, P3.View.height);
            this._quad.endFill();
        }

        /**
         * @returns {number}
         */

    }, {
        key: "color",
        get: function get() {
            return this._color;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "duration",
        get: function get() {
            return this._duration;
        }
    }]);

    return FadeTransition;
}(_Transition3.default);

exports.default = FadeTransition;

},{"./Transition":26}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3.transition
 */
var Transition = function (_PIXI$Container) {
    _inherits(Transition, _PIXI$Container);

    function Transition() {
        _classCallCheck(this, Transition);

        /**
         * @member {Object}
         */
        var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this));

        _this.signals = {};

        /**
         * @member {signals.Signal}
         */
        _this.signals.in = new signals.Signal();

        /**
         * @member {signals.Signal}
         */
        _this.signals.out = new signals.Signal();

        _this.on("added", _this.init, _this);
        return _this;
    }

    _createClass(Transition, [{
        key: "init",
        value: function init() {
            this.off("added", this.init);

            this.interactive = true;
        }

        /**
         * @param options
         * @param [options.children=false]
         * @param [options.texture=false]
         * @param [options.baseTexture=false]
         */

    }, {
        key: "destroy",
        value: function destroy(options) {
            this.signals.in.dispose();
            this.signals.out.dispose();

            _get(Transition.prototype.__proto__ || Object.getPrototypeOf(Transition.prototype), "destroy", this).call(this, options);
        }

        /**
         */

    }, {
        key: "in",
        value: function _in() {
            this.signals.in.dispatch(this);
        }

        /**
         */

    }, {
        key: "out",
        value: function out() {
            this.signals.out.dispatch(this);
        }

        /**
         */

    }, {
        key: "resize",
        value: function resize() {
            // override
        }
    }]);

    return Transition;
}(PIXI.Container);

exports.default = Transition;

},{}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FadeTransition = require("./FadeTransition");

Object.defineProperty(exports, "FadeTransition", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FadeTransition).default;
  }
});

var _Transition = require("./Transition");

Object.defineProperty(exports, "Transition", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Transition).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./FadeTransition":25,"./Transition":26}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.utils
 */
var ObjectPool = function () {
    /**
     * @param {*} t
     * @param {number} size
     * @param {Array} args
     */
    function ObjectPool(t, size, args) {
        _classCallCheck(this, ObjectPool);

        /**
         * @member {*}
         * @protected
         */
        this._t = t;

        /**
         * @type {Array}
         * @private
         */
        this._args = args || [];

        /**
         * @member {Array.<*>}
         * @protected
         */
        this._free = [];

        /**
         * @member {Array.<*>}
         * @protected
         */
        this._used = [];

        this.expand(Math.max(1, size));
    }

    /**
     */


    _createClass(ObjectPool, [{
        key: "destroy",
        value: function destroy() {
            for (var i = 0; i < this._free.length; ++i) {
                var object = this._free[i];
                object && object.destroy && object.destroy();
            }
            this._free.length = 0;

            for (var _i = 0; _i < this._used.length; ++_i) {
                var _object = this._used[_i];
                _object && _object.destroy && _object.destroy();
            }
            this._used.length = 0;
        }

        /**
         * @param {number} size
         */

    }, {
        key: "expand",
        value: function expand(size) {
            for (var i = 0; i < size; ++i) {
                var object = Object.create(this._t.prototype);
                object.constructor = this._t;
                this._t.apply(object, this._args);
                this._free.push(object);
            }
        }

        /**
         * @returns {*}
         */

    }, {
        key: "create",
        value: function create() {
            var object = this._free.shift();
            if (!object) return null;

            object.init && object.init();
            this._used.push(object);
            return object;
        }

        /**
         * @param {*} obj
         * @returns {boolean}
         */

    }, {
        key: "free",
        value: function free(obj) {
            var index = this._used.indexOf(obj);
            if (index !== -1) {
                obj.reset && obj.reset();
                this._free.push(obj);
                this._used.splice(index, 1);
            }
            return index !== -1;
        }

        /**
         * @returns {*}
         */

    }, {
        key: "baseClass",
        get: function get() {
            return this._t;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "size",
        get: function get() {
            return this._free.length + this._used.length;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "available",
        get: function get() {
            return this._free.length;
        }
    }]);

    return ObjectPool;
}();

exports.default = ObjectPool;

},{}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ObjectPool = require("./ObjectPool");

Object.defineProperty(exports, "ObjectPool", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_ObjectPool).default;
    }
});
exports.copyObject = copyObject;
exports.copyOwnPropertiesFrom = copyOwnPropertiesFrom;
exports.padNum = padNum;
exports.selectRandom = selectRandom;
exports.isCocoonJS = isCocoonJS;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an identical copy of an object.
 * http://speakingjs.com/es5/ch17.html#code_copyOwnPropertiesFrom
 *
 * @param {Object} original
 * @param {boolean} [deep=true]
 * @returns {Object}
 */
function copyObject(original) {
    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var copy = Object.create(Object.getPrototypeOf(original));
    copyOwnPropertiesFrom(copy, original, deep);
    return copy;
}

/**
 * Copies all of an object's properties to the target object.
 * http://speakingjs.com/es5/ch17.html#code_copyOwnPropertiesFrom
 *
 * @param {Object} target
 * @param {Object} source
 * @param {boolean} [deep=true]
 * @returns {Object}
 */
function copyOwnPropertiesFrom(target, source) {
    var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    Object.getOwnPropertyNames(source).forEach(function (key) {
        var descriptor = Object.getOwnPropertyDescriptor(source, key);
        Object.defineProperty(target, key, descriptor);
        if (deep && _typeof(descriptor.value) === "object" && descriptor.value !== null) {
            target[key] = P3.utils.copyObject(source[key], deep);
        }
    });
    return target;
}

/**
 * Returns a value converted to a zero padded string.
 *
 * @param {number} n - The value to pad.
 * @param {number} [width=0] - The number of zeros to pad the string with.
 * @returns {string}
 */
function padNum(n) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var num = Math.abs(n);
    var zeros = Math.max(0, width - Math.floor(num).toString().length);
    var zeroStr = Math.pow(10, zeros).toString().substr(1);
    if (num < 0) {
        zeroStr = "-" + zeroStr;
    }
    return zeroStr + num;
}

/**
 * @param {Array} arr
 * @returns {*}
 */
function selectRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * @returns {boolean}
 */
function isCocoonJS() {
    return typeof navigator["isCocoonJS"] !== "undefined";
}

},{"./ObjectPool":28}]},{},[21])

